import React, { Component } from 'react';
import { isEqual, } from 'Utils/lodashUtils.js';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PrimaryButton from 'Components/Button/PrimaryButton';
import NumberedRoundButton from 'Components/Button/NumberedRoundButton';
import Button from 'Components/Button/Button';
import classnames from 'classnames';
import './IssuerActions.scss';
import ResponseBanner from 'Components/cards/ResponseBanner';
import ActionIssuerComponents from '../ActionIssuerComponents/ActionIssuerComponents';
import { resetNestedFieldSelectorData } from 'Actions/nestedFieldSelectorAction.js';
import EmptyState from 'Components/EmptyState/EmptyState';
// APIs
import { getLedgersForCase } from 'Apis/caseManagerAPI.js';
import { fetchLedgers, getActionDescriptions, getRIDResponseReasonCodeDescription, getResponseReasonCodeDescriptions as getSecondaryCodeList, getLiabilityDescription, getPrevFinancialsData, logWarningEvent } from 'Apis/caseDataAPI';
import { getImageDataForCaseNumber } from 'Apis/imageReaderApi';
import { submitTakeActionResponse, validateIssuerSentDocs } from 'Apis/serviceCaseActionApi';
import { attachDocuments } from 'Apis/imageMatcherApi';
import { getPredefinedMessage, getLetterTemplates, checkInstitutionName } from '../../api/caseDataAPI';
import { getMerchantData, getCurrencyConversionRate } from '../../api/referenceDataApi';
import moment from 'moment';
// Configs
import { transformDataForReviewScreen, computeBalanceFromInputField } from 'Selectors/nestedFieldSelectors';
import {
  getTranslations,
  getActionPaneData,
  getAttachArray,
  getUnableToDefendOrPursueData,
  getDefendOrPursueAttachArray,
  getGoodWillData,
  getGoodWillAttachArray,
  getAdditionalInfoData,
  getAdditionalInfoAttachArray,
  getNotifyAndRequestDocs,
  getNotifyAndRequestDocsAttachArray,
  getMasterCardPCFActionPaneData,
  getVisaCardPCFActionPaneData,
  getProsaCardPCFActionPaneData,
  getEvoCardPCFActionPaneData,
  getPCFAttachArray,
  getTakeActionCloseCaseData,
  getTakeActionCloseCaseAttachArray,
  getTakeActionCloseCasePinDebitAttachArray,
  getTakeActionTransferCaseData,
  getVisaActionPaneData,
  getUnableToFullfillData,
  getProsaUnableToFullfillData,
  getUnableToFulfillAttachArray,
  getVisaGoodWillAttachArray,
  getVisaDefendOrPursueAttachArray,
  getMasterCardGoodWillAttachArray,
  getMasterCardDefendOrPursueAttachArray,
  getMasterCardActionPaneData,
  getProsaActionPaneData,
  getDiscoverCardBrandActionPaneData,
  getMasterCardBrandActionPaneData,
  getCardBrandAttachArray,
  getUploadDocumentData,
  getGoodFaithPCFActionPaneData,
  getAmexActionPaneData,
  getEVOCardRIDActionPaneData,


} from 'Containers/ActionPane/configStructure';

// Utils
import { transformFinancialAdjustmentDataSubmit, transformFinancialAdjustmentDataReview, getQuestionSubmitData, getIssuerDocData } from 'Utils/formatting.js';
import * as ActionConstants from './ActionConstants.js';
import * as KeyConstants from 'Utils/constants/keyConstants.js';
import { getCardBrandCode } from 'Utils/functionalUtils.js';

import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
// Styles
import './IssuerActions.scss';
import { getLiabilitySubmitData, getWriteOffReasonSubmitData, getCloseCaseSubmitData, getMerchantMessageSubmitData, getRecordCaseRulingSubmitData } from 'Utils/formatting';
import { transferCase, getTransferToList, getTransferPurposeList } from '../../api/caseDataAPI';
import FinancialsBanner from 'Components/cards/FinancialsBanner/FinancialsBanner';
import financialsLogo from 'Components/cards/FinancialsBanner/icon_warning.svg';
import { fetchDocumentsForCase, resetDocumentsForCase, resetSelectedDocuments, updateEditedPages, updateSelectedCasePages } from '../../actions/caseDocumentsAction';
import { VITE_DEFAULT_LETTER_TEMPLATE_LANGUAGE_ID } from 'Constants/appEnvConstants';
import ImagePortal from '../ImagePortal/ImagePortal';

const __PCF_ACTION_CODE__ = 'PCF';
const __FILE_COMPLIANCE__ = "File Compliance";
const __CREATE_GOOD_FAITH = "Create Good Faith Request";
const __INITIATE_PRE_COMPLIANCE__ = "Initiate Pre-compliance";
const __GOOD_FAITH_TYPES__ = [{ value: 13, text: 'Incoming Good Faith' }, { value: 14, text: 'Outgoing Good Faith' }];
const __QUESTIONNAIRE__ = "Questionnaire";
const disputeStages = [2, 4, 5, 8, 9, 10, 11, 12, 19, 20];
const acquirerCodes = ["GPN", "HPY", "MXI", "MXP","EMD","EMI","GPE"];
const evoAcquirerCodes = ["EMD","EMI"];
let defaultConfigLedgers = [];
let updatedAcceptanceAmount = {};
let apiLedgerData= [];
let showApiLedgerFlag = true;

class IssuerActions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      jsonHeadings: [],
      translations: [],
      isFinancialAdjustmentWarning: false,
      isAnnex19Present :!(this.props.isAnnex19DocPresent),
      isIssuerDocError: false,
      isVisible: props.selectedActionPanelDetailItem !== undefined ? props.selectedActionPanelDetailItem.isVisible : false,
      showComponent: true,
      showText: false,
      textId: 0,
      primaryButtonText: 'Next Step',
      isActive: true,
      disabled: true,
      data: {},
      isDataUploaded: false,
      bannerResponseMessage: '',
      isError: false,
      commentText: '',
      selectedCaseNumber: this.props.caseNumber,
      selectedIssuerIndex: 0,
      attachArray: [],
      selectedActionPanelId: -1,
      imageData: [],
      maxActionIssuerLength: 0,
      respondToIssuerData: [],
      actionDescriptionList: [],
      cancelButtonText: 'Cancel',
      secondaryButtonText: '',
      issuerActionData: [],
      checkBoxStatus: [],
      buttonStatus: [],
      pageCount: {},
      addClass: false,
      respondToIssuerPostData: {},
      representmentQuestion: {
        documentsForIssuer: [
          {
            base64EncodedImage: 'string',
            imageFormat: 'png',
          },
        ],
        issuerDocumentsProvided: true,
        messageText: 'string',
        stageConfigId: 0,
      },
      representmentQuestion: {
        documentsForIssuer: [
          {
            base64EncodedImage: 'string',
            imageFormat: 'string',
          },
        ],
        issuerDocumentsProvided: true,
        messageText: 'string',
        stageConfigId: 3,
      },
      merchantMessage: {
        documentsForMerchant: [
          {
            base64EncodedImage: 'string',
            imageFormat: 'string',
          },
        ],
        letterMessage: '',
        merchPrefLangLetterMessage: '',
        letterTemplateLanguageId: 0,
        merchantDocumentsProvided: false,
        returnToPDRFlag:false,
        reasonForAdditionalReview: '',
      },
      reasonForAdditionalReviewLength:0,
      merchantMsgPresent:true,
      pdrReasonPresent:true,
      merchantMessageTemp: [],
      messageType: {
        value: '',
        text: '',
      },
      englishMessage: '',
      otherMessage: '',
      predefMessageData: {
        englishLanguage: '',
        preferredLanguage: '',
      },
      letterTemplate: {
        value: 'choose-one',
        text: 'Choose One',
      },
      financialAdjustment: {
        ledgerInputList: [
          {
            acquirerCode: 'string',
            amount: 0,
            internalNotes: 'string',
            ledgerAccountNumber: 'string',
            ledgerAdjustment: 'string',
          },
        ],
      },
      comment: {
        commentText: '',
        externalComment: false,
      },
      userId: 'testAnalyst',
      ledgers: [],
      closeCaseSubmitPerform: false,
      checkBoxStatusForNextStep: true,
      isMerchantMessageError: false,
      isMerchantMessageAvailable: true,
      isSubmitButtonClicked: false,
      supportDocumentInd: '0',
      disableUploadNext: true,
      goodFaithTypes: [],
      primaryRuleViolationList: [],
      customWarningMessage: "",
      warningType : "",
      caseAdjustment: "",
      imageContentsErr: true,
      date:{},
      visaQnReviewData: [],
      showIssuerDocWarning: false,
      issuerDocWarningMessage: ""
    };
    updatedAcceptanceAmount = {
      amount: 0,
      currency : props.disputeCurrencyCode
    };
    this.attachBindings();
  }

  attachBindings() {
    this.onDisableNextStep = this.onDisableNextStep.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.closeActionPane = this.closeActionPane.bind(this);
    this.onEndEdit = this.onEndEdit.bind(this);
    this.showErrorBanner = this.showErrorBanner.bind(this);
    this.showIssuerDocErrorBanner = this.showIssuerDocErrorBanner.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.attachDocumentPage = this.attachDocumentPage.bind(this);
    this.previousIssuerPage = this.previousIssuerPage.bind(this);
    this.updateCheckBoxStatus = this.updateCheckBoxStatus.bind(this);
    this.setSelectionList = this.setSelectionList.bind(this);
    this.getCaseNumberImageData = this.getCaseNumberImageData.bind(this);
    this.getCardBrandDisputeActionDescriptions = this.getCardBrandDisputeActionDescriptions.bind(this);
    this.updatePageListArray = this.updatePageListArray.bind(this);
    this.submitAction = this.submitAction.bind(this);
    this.getAdjustFinancialDataForSubmit = this.getAdjustFinancialDataForSubmit.bind(this);
    this.getAdjustFinancialDataForReview = this.getAdjustFinancialDataForReview.bind(this);
    this.fetchEnglishMessageData = this.fetchEnglishMessageData.bind(this);
    this.fetchOtherMessageData = this.fetchOtherMessageData.bind(this);
    this.fetchPredefMessageData = this.fetchPredefMessageData.bind(this);
    this.fetchMerchantDocumentFlag = this.fetchMerchantDocumentFlag.bind(this);
    this.fetchLangId = this.fetchLangId.bind(this);
    this.setsubmitResponseBanner = this.setsubmitResponseBanner.bind(this);
    this.setIssuerPageIndexes = this.setIssuerPageIndexes.bind(this);
    this.gotoNextStep = this.gotoNextStep.bind(this);
    this.fetchMessageType = this.fetchMessageType.bind(this);
    this.showWarningBanner = this.showWarningBanner.bind(this);
    this.setCancelResponseBanner = this.setCancelResponseBanner.bind(this);
    this.updateNextButtonStatus = this.updateNextButtonStatus.bind(this);
    this.fetchLedgers = this.fetchLedgers.bind(this);
    this.setActionPanelJsonData = this.setActionPanelJsonData.bind(this);
    this.closeActionForIssuerAction = this.closeActionForIssuerAction.bind(this);
    this.acceptFinancialLoss = this.acceptFinancialLoss.bind(this);
    this.setInitialState = this.setInitialState.bind(this);
    this.getfinancialAdjustmentData = this.getfinancialAdjustmentData.bind(this);
    this.getDeadlineDate = this.getDeadlineDate.bind(this);
    this.handleSingleDateChange = this.handleSingleDateChange.bind(this);
    this.prePopulateDate = this.prePopulateDate.bind(this);
    this.filterTakeActionPageDetailList = this.filterTakeActionPageDetailList.bind(this);
    this.validateTextArea = this.validateTextArea.bind(this);
    this.validateTextAndAgreementStatus = this.validateTextAndAgreementStatus.bind(this);
    this.validateDropDownAndTextArea = this.validateDropDownAndTextArea.bind(this);
    this.setActionData = this.setActionData.bind(this);
    this.checkBoxFlag = this.checkBoxFlag.bind(this);
    this.settingReturnToPDRFlag = this.settingReturnToPDRFlag.bind(this);
    this.settingReasonForAdditionalReview = this.settingReasonForAdditionalReview.bind(this);
    this.resetAttachPageData = this.resetAttachPageData.bind(this);
    this.validateComboSearchDropDown = this.validateComboSearchDropDown.bind(this);
    this.getPurposeOfTransfer = this.getPurposeOfTransfer.bind(this);
    this.getTransferToList = this.getTransferToList.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.checkErrorFlag = this.checkErrorFlag.bind(this);
    this.getLanguageIndCode = this.getLanguageIndCode.bind(this);
    this.fetchPredefinedMessages = this.fetchPredefinedMessages.bind(this);
    this.mapLanguage = this.mapLanguage.bind(this);
    this.fetchLetterTemplates = this.fetchLetterTemplates.bind(this);
    this.getLetterTemplatesLength = this.getLetterTemplatesLength.bind(this);
    this.updateJSONHeadingsPage = this.updateJSONHeadingsPage.bind(this);
    this.setRequestAdditionalWarningBanner = this.setRequestAdditionalWarningBanner.bind(this);
    this.setQuestionnaireData = this.setQuestionnaireData.bind(this);
    this.setVisaQuestionnaireSubmitData = this.setVisaQuestionnaireSubmitData.bind(this);
    this.fetchFinancialCaseDetails = this.fetchFinancialCaseDetails.bind(this);
    this.fetchInitialData = this.fetchInitialData.bind(this);
    this.initializeDataLoader = this.initializeDataLoader.bind(this);
    this.getResponseReasonDescription = this.getResponseReasonDescription.bind(this);
    this.fileUploaded = this.fileUploaded.bind(this);
    this.setInputTextAndDate = this.setInputTextAndDate.bind(this);
    this.resetTextAndDate = this.resetTextAndDate.bind(this);
    this.setResponseReasonList = this.setResponseReasonList.bind(this);
    this.getPrimaryRuleViolationList = this.getPrimaryRuleViolationList.bind(this);
    this.setPrimaryViolationRules = this.setPrimaryViolationRules.bind(this);
    this.getCasefilingTypes = this.getCasefilingTypes.bind(this);
    this.getResponseReasonList = this.getResponseReasonList.bind(this);
    this.resetMerchantMessages = this.resetMerchantMessages.bind(this);
    this.setAdjustmentLedgerForAcceptance = this.setAdjustmentLedgerForAcceptance.bind(this);
    this.getReasonCode = this.getReasonCode.bind(this);
    this.updateSelectedCaseDocuments = this.updateSelectedCaseDocuments.bind(this);
    this.setQuestionnaireReviewData = this.setQuestionnaireReviewData.bind(this);
  }

  componentWillMount() {
    document.addEventListener(ActionConstants.__ON_KEY_DOWN__, this.onKeyPress);
    document.addEventListener(ActionConstants.__ON_KEY_PRESS__, this.onKeyPress);
    this.setActionPanelJsonData(this.props);
    this.fetchInitialData(this.props);
    this.setAdjustmentData(this.props);
  }

  setQuestionnaireReviewData(visaQnReviewData) {
    this.setState({
      visaQnReviewData: visaQnReviewData,
    });
  }

  fetchFinancialCaseDetails(props) {
    const acqCode = (props.acquirerCode === 'MXP' || props.acquirerCode === 'MXI' ? "GPN" : props.acquirerCode);
    this.fetchLedgers(acqCode, props.merchantRegionCode);
    this.getfinancialAdjustmentData(props.caseNumber, props.actionViewCode,acqCode);
  }
  
  checkBoxFlag(flag) {
    this.setState({
      checkBoxStatusForNextStep: flag,
    });
  }

  settingReturnToPDRFlag(returnToPDRFlag){
    this.setState({
      merchantMessage: {
        ...this.state.merchantMessage,
        returnToPDRFlag,
        reasonForAdditionalReview:''
      },
      pdrReasonPresent: !returnToPDRFlag,
    },() => {
      const disableFlag = (
        this.state.merchantMessage.reasonForAdditionalReview.length == 0 && 
        !this.state.merchantMessage.reasonForAdditionalReview.replace(/\s/g, '').length) 
        ? true : false;

      this.onDisableNextStep(
        !this.state.merchantMessage.returnToPDRFlag ? false : disableFlag,
        this.state.skipNotifyMerchant);
    }); 
  }

  settingReasonForAdditionalReview(reasonForAdditionalReview){
    this.setState({
      reasonForAdditionalReviewLength:reasonForAdditionalReview.length,
      merchantMessage: {
        ...this.state.merchantMessage,
        reasonForAdditionalReview
      },
      pdrReasonPresent: reasonForAdditionalReview !=='' ? true : false ,
    },()=>{
        const disableFlag = (
          this.state.merchantMessage.reasonForAdditionalReview.length == 0 && 
          !this.state.merchantMessage.reasonForAdditionalReview.replace(/\s/g, '').length) ? true : false;
  
        this.onDisableNextStep(disableFlag,this.state.skipNotifyMerchant);
      })
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedActionPanelDetailItem !== undefined && this.props.selectedActionId !== nextProps.selectedActionId && this.state.jsonHeadings.length > 0) {
      this.setActionPanelJsonData(nextProps);
      this.setState({
        maxActionIssuerLength: this.state.jsonHeadings.length,
        selectedIssuerIndex: 0,
        isVisible: nextProps.selectedActionPanelDetailItem.isVisible,
        textId: parseInt(nextProps.selectedActionId),
        primaryButtonText: nextProps.selectedActionPanelDetailItem.actionPrimaryButtonText,
        cancelButtonText: this.state.jsonHeadings[0].cancelButtonText,
        secondaryButtonText: '',
      });
      this.fetchInitialData(nextProps);
    } else if (this.props.caseNumber !== undefined && this.props.caseNumber !== nextProps.caseNumber) {
      this.getLanguageIndCode(nextProps);
      this.closeActionPane();
      if (nextProps.selectedActionId == ActionConstants.__TRANSFER_CASE_ID__) {
        this.getPurposeOfTransfer();
        this.getTransferToList();
      }
    } else if (this.props.caseStageDetail.caseStageId !== undefined && this.props.caseStageDetail.caseStageId !== nextProps.caseStageDetail.caseStageId) {
      this.setState({
        maxActionIssuerLength: this.state.jsonHeadings.length,
        selectedIssuerIndex: 0,
        isVisible: nextProps.selectedActionPanelDetailItem.isVisible,
        textId: parseInt(nextProps.selectedActionId),
        caseStageId: nextProps.caseStageDetail.caseStageId,
      });
      this.fetchInitialData(nextProps);
    }
    this.setAdjustmentData(nextProps);
  }

  setAdjustmentData(nextProps) {
    if (JSON.parse(JSON.stringify(this.props.adjustFinancialsData)) != JSON.parse(JSON.stringify(nextProps.adjustFinancialsData))) {
      let financialDataClone = { ...this.state.financialData };
     if(!showApiLedgerFlag){
      financialDataClone["caseAmount"] = updatedAcceptanceAmount;
      financialDataClone["caseAmountCurrency"] = this.props.disputeCurrencyCode;
      financialDataClone["balanceAmount"] =  0;
     }
      if (nextProps.adjustFinancialsData.data.length < this.props.adjustFinancialsData.data.length) {
        // Remove the leger as it is deleted from field selector
        for (const key in ActionConstants.PRE_POPULATED_FIELD_MAP) {
          const ledgerSelectedIndex = nextProps.adjustFinancialsData.data.findIndex((list) => {
            return list.name && list.name.split(':')[0] === key;
          });
          if (ledgerSelectedIndex === -1) {
            financialDataClone[ActionConstants.PRE_POPULATED_FIELD_MAP[key]] = {
              currency: financialDataClone.caseAmount !== undefined ? financialDataClone.caseAmount.currency : '',
              amount: '',
            };
          }
        }
      }
      else {
        // Update the value for display panel as user changes from the input box.
        if (nextProps.adjustFinancialsData.data.length > 0) {
          nextProps.adjustFinancialsData.data.forEach((ledgerList) => {
            const selectedAccNo = ActionConstants.PRE_POPULATED_FIELD_MAP[ledgerList.name && ledgerList.name.split(':')[0]];
            if (selectedAccNo !== undefined) {
              financialDataClone[selectedAccNo] = {
                currency: financialDataClone.caseAmount !== undefined ? financialDataClone.caseAmount.currency : '',
                amount: ledgerList.v1 === undefined ? ledgerList.v2 : ledgerList.v1,
              };
            }
          });
          nextProps.nestedFieldSelectorData.list.forEach((unSelected) => {
            const selectedAccNo = ActionConstants.PRE_POPULATED_FIELD_MAP[unSelected.value && unSelected.value.split(':')[0]];
            if (unSelected.lockedBy === -1 && selectedAccNo !== undefined) {
              financialDataClone[selectedAccNo] = {
                currency: financialDataClone.caseAmount !== undefined ? financialDataClone.caseAmount.currency : '',
                amount: '',
              };
            }
          });
        }
      }
      // Update the data based on above execution flow
      this.setState({
        financialData: financialDataClone,
        customWarningMessage: "",
        isFinancialAdjustmentWarning: false,
      });
    }
  }

  fetchInitialData(nextProps) {
    this.setState({
      skipNotifyMerchant: false,
      customWarningMessage: "",
      isFinancialAdjustmentWarning: false,
    })
    const selectedActionId = parseInt(nextProps.selectedActionId);
    this.initializeDataLoader();
    switch (selectedActionId) {
      case ActionConstants.__TRANSFER_CASE_ID__:
        this.getPurposeOfTransfer();
        this.getTransferToList();
        break;
      case ActionConstants.__NOTIFY_REQUEST_DOCS_ID__:
        this.setState({
          isImageDataLoading: true,
        })
        this.getCaseNumberImageData(nextProps.caseNumber);
        this.getLanguageIndCode(nextProps);
        this.fetchFinancialCaseDetails(nextProps);
        break;
      case ActionConstants.__REQUEST_ADDITIONAL_INFO_ID__:
        this.setState({
          isImageDataLoading: true,
        })
        this.getCaseNumberImageData(nextProps.caseNumber);
        this.getLanguageIndCode(nextProps);
        break;
      case ActionConstants.__RESPOND_TO_ISSUER_ID__:
      case ActionConstants.__PURSUE_CASE_FILLING_ID__:
      case ActionConstants.__WRITEOFF_GOODWILL_ID__:
      case ActionConstants.__UNABLE_TO_DEFEND_PURSUE_ID__:
        this.setState({
          isLoadingActionDescriptions: true,
          isImageDataLoading: true,
        })
        this.getCaseNumberImageData(nextProps.caseNumber,ActionConstants.__RESPOND_TO_ISSUER_ID__);
        this.getCardBrandDisputeActionDescriptions(nextProps);
        this.getLanguageIndCode(nextProps);
        this.fetchFinancialCaseDetails(nextProps);
        this.checkInstitutionNameAndSetWarning(nextProps);
        if (ActionConstants.__PURSUE_CASE_FILLING_ID__ == selectedActionId) {
          this.setState({
            isGoodFaithLoading: true,
            isPrimaryRulesLoading: true,
          })
          this.getPrimaryRuleViolationList();
        }
        ActionConstants.__RESPOND_TO_ISSUER_ID__ == selectedActionId && nextProps.caseStageDetail.disputeStageName == 'Chargeback' && nextProps.caseStageDetail.cardBrandCode == ActionConstants.__MASTERCARD_BRAND_CODE__ && (!(nextProps.caseNumber !== undefined && nextProps.caseNumber.toString().startsWith("5"))) && this.getResponseReasonDescription(nextProps);
        break;
      case ActionConstants.__RESPOND_TO_CARD_BRAND_ID__:
        this.setState({
          isLoadingActionDescriptions: true,
          isImageDataLoading: true,
        })
        this.getCaseNumberImageData(nextProps.caseNumber);
        this.getCardBrandDisputeActionDescriptions(nextProps);
        break;
      case ActionConstants.__CLOSE_CASE_ID__:
        this.getLanguageIndCode(nextProps);
        this.fetchFinancialCaseDetails(nextProps);
        break;
      case ActionConstants.__UNABLETO_FULFILL_ID__:
        this.setState({
          isLoadingActionDescriptions: true,
          isImageDataLoading: true,
        })
        this.getLanguageIndCode(nextProps);
        this.getCardBrandDisputeActionDescriptions(nextProps);
        this.getCaseNumberImageData(nextProps.caseNumber);
        break;
      case ActionConstants.__PURSUE_CASE_FILLING_ID__:
        this.setState({
          isLoadingActionDescriptions: true,
          isImageDataLoading: true,
        })
        this.getCaseNumberImageData(nextProps.caseNumber);
        this.getLanguageIndCode(nextProps);
        this.fetchFinancialCaseDetails(nextProps);
        break;
        case ActionConstants.__REQUEST_ISSUER_DOCUMENT_ID__:
          this.setState({
            isLoadingActionDescriptions: true,
          })
          this.getCardBrandAnnex19Descriptions(nextProps);
            break;
    }
  }


  initializeDataLoader() {
    this.setState({
      isImageDataLoading: undefined,
      isTransferPurposeLoading: undefined,
      isLoadingActionDescriptions: undefined,
      isTransferListLoading: undefined,
      isMerchantDataLoading: undefined,
      isLedgerDataLoading: undefined,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.adjustFinancialsData.data.length > 0 && this.props.selectedActionId == prevProps.selectedActionId) {
      const isMERCHANT_GL = this.props.adjustFinancialsData.data.findIndex((selectedLedger) => {
        return selectedLedger.name === ActionConstants.MERCHANT_GL;
      }) != -1;
      const prevIsMerchantGl = prevProps.adjustFinancialsData.data.findIndex((selectedLedger) => {
        return selectedLedger.name === ActionConstants.MERCHANT_GL;
      }) != -1;
      const index = 2;
      if (ActionConstants.__WRITEOFF_GOODWILL_ID__ == this.props.selectedActionId || ActionConstants.__CLOSE_CASE_ID__ == this.props.selectedActionId) {
        const page = ActionConstants.__WRITEOFF_GOODWILL_ID__ == this.props.selectedActionId ? getGoodWillData()[index] : getTakeActionCloseCaseAttachArray()[index];;
        if (isMERCHANT_GL) {
          this.updateJSONHeadingsPage(ActionConstants.__PUSH__, page, index);
        } else if (prevIsMerchantGl) {
          this.updateJSONHeadingsPage(ActionConstants.__POP__, page, index);
        }
      }
    }
    // fetch case docs
    if(!isEqual(prevProps.caseDocuments, this.props.caseDocuments)) {
      this.setState({
        supportDocumentInd: '1',
        imageContentsErr: false,
        isImageDataLoading: false,
      });
    }
  }
  componentWillUnmount() {
    document.removeEventListener(ActionConstants.__ON_KEY_DOWN__, this.onKeyPress);
    document.removeEventListener(ActionConstants.__ON_KEY_PRESS__, this.onKeyPress);
    this.props.resetNestedFieldSelectorData();
    this.props.resetDocumentsForCase();
  }

  setInitialState() {
    this.setState({
      jsonHeadings: [],
      translations: [],
      uploadFileList: [],
      isVisible: this.props.selectedActionPanelDetailItem !== undefined ? this.props.selectedActionPanelDetailItem.isVisible : false,
      showComponent: true,
      showText: false,
      textId: 0,
      primaryButtonText: 'Next Step',
      isActive: true,
      disabled: true,
      data: {},
      isDataUploaded: false,
      bannerResponseMessage: '',
      isError: false,
      commentText: '',
      selectedCaseNumber: this.props.caseNumber,
      selectedIssuerIndex: 0,
      attachArray: [],
      selectedActionPanelId: -1,
      imageData: [],
      maxActionIssuerLength: 0,
      respondToIssuerData: [],
      cancelButtonText: 'Cancel',
      secondaryButtonText: '',
      issuerActionData: [],
      checkBoxStatus: [],
      buttonStatus: [],
      pageCount: {},
      addClass: false,
      respondToIssuerPostData: {},
      representmentQuestion: {
        documentsForIssuer: [
          {
            base64EncodedImage: 'string',
            imageFormat: 'png',
          },
        ],
        issuerDocumentsProvided: true,
        messageText: 'string',
        stageConfigId: 0,
      },
      merchantMessage: {
        documentsForMerchant: [
          {
            base64EncodedImage: 'string',
            imageFormat: 'string',
          },
        ],
        letterMessage: '',
        merchPrefLangLetterMessage: '',
        letterTemplateLanguageId: 0,
        merchantDocumentsProvided: false,
        returnToPDRFlag:false,
        reasonForAdditionalReview: '',
      },
      reasonForAdditionalReviewLength:0,
      merchantMessageTemp: [],
      messageType: {
        value: '',
        text: '',
      },
      englishMessage: '',
      otherMessage: '',
      predefMessageData: {
        englishLanguage: '',
        preferredLanguage: '',
      },
      letterTemplate: {
        value: 'choose-one',
        text: 'Choose One',
      },
      representmentQuestion: {
        documentsForIssuer: [
          {
            base64EncodedImage: 'string',
            imageFormat: 'string',
          },
        ],
        issuerDocumentsProvided: true,
        messageText: 'string',
        stageConfigId: 3,
      },
      comment: {
        commentText: '',
        externalComment: false,
      },
      userId: 'testAnalyst',

    });
  }

  /**
   * Get language Indicator code
   */
  getLanguageIndCode(props) {
    let langIndCode = props.languageIndCode === null || props.languageIndCode == undefined ? 'EN' : props.languageIndCode;
    let acquirerCode = props.acquirerCode;
    let caseNumber = props.caseNumber;
    let cardBrandCode = getCardBrandCode(acquirerCode,props.caseStageDetail.cardBrandCode);
    let actionViewCode = props.actionViewCode;
    let disputeStageId = props.caseStageDetail.disputeStageId;
    this.fetchPredefinedMessages(langIndCode, props);
    this.mapLanguage(langIndCode);
    this.fetchLetterTemplates(langIndCode, acquirerCode, actionViewCode, cardBrandCode, disputeStageId);
  }
  /**
   * Fetch pre defined messages.
   * @param {*} languageIndCode 
   */
  fetchPredefinedMessages(languageIndCode, props) {
    getPredefinedMessage(languageIndCode, props.caseStageDetail.caseStageId)
      .then((apiResponse) => {
        this.setState({
          predefMessages: apiResponse.data,
          duplicatePredefMessages: apiResponse.data,
        });
      })
      .catch((error) => {
        this.setState({
          isMerchantDataLoading: false,
          isFetchLetterInProgress: false,
        })
        console.log('Unable to fetch letter template', error);
      });
  }

  /**
   * This method is responsible fo mapping language code and text
   * @param {} langIndCode 
   */
  mapLanguage(langIndCode) {
    ActionConstants.languageMapper.forEach((language) => {
      if (langIndCode === language.languageIndCode) {
        this.setState({
          languageIndCode: langIndCode,
          languageText: language.languageText,
        });
      }
    });
  }

  /**
   * This method is responsible for fetching letter Templates
   * @param {langIndCode} langIndCode 
   * @param {acquirerCode} acquirerCode
   * @param {actionViewCode} actionViewCode
   * @param {cardBrandCode} cardBrandCode
   * @param {disputeStageId} disputeStageId
   */
  fetchLetterTemplates(langIndCode, acquirerCode, actionViewCode, cardBrandCode, disputeStageId) {
    const letterTemp = [];
    const stateSelections = { ...this.state.selections };
    //tempary fix for GPX acquirer code to fetch letter templates from GPN
    const acquirerCodeForLetter = acquirerCode === 'GPX' ? 'GPN' : acquirerCode;
    return getLetterTemplates(langIndCode, acquirerCodeForLetter, actionViewCode, cardBrandCode, disputeStageId)
      .then((apiResponse) => {
        apiResponse.data.forEach((element) => {
          const template = {
            value: element.letterTemplateLanguageId,
            text: element.letterTemplateName,
          };
          letterTemp.push(template);
        });
        this.getLetterTemplatesLength(letterTemp.length);
        this.setState({
          letterTemplates: letterTemp,
          selections: stateSelections,
          isMerchantDataLoading: false,
          isFetchLetterInProgress: false,
         });
      })
      .catch((error) => {
        this.checkErrorFlag(true);
        this.setState({
          isMerchantDataLoading: false,
          isFetchLetterInProgress: false,
        })
      });
  }

  getLetterTemplatesLength(length) {
    if (length > 0) {
      this.setState({ isMerchantMessageAvailable: false });
    } else {
      this.setState({ isMerchantMessageAvailable: true });
    }


  }
  //API call to fetch puprpose for transfer
  getPurposeOfTransfer() {
    this.setState({
      isTransferPurposeLoading: true,
    })
    getTransferPurposeList().then((apiResponse) => {
      if (apiResponse.status.statusCode === 2000) {
        this.setSelectionList(apiResponse.data, ActionConstants.__TRANSFER_CASE_TRANSFERTO_ID__);
      }
      this.setState({
        isTransferPurposeLoading: false,
      })
    }).catch((error) => {
      this.setState({
        isTransferPurposeLoading: false,
      })
      console.log('Error Occured while fetching Purpose of transfer list', error);
    });

  }

  isDisabledHandler = (fileList) => {
    let isDisabled = true;
    if (fileList.length > 0 && fileList.every(file => file.isSelected === true && file.isUploaded === true)) {
      isDisabled = false;
    }

    this.updateNextButtonStatus(isDisabled);
  }

  fileUploaded = (status, fileList) => {
    this.setState({
      uploadFileList: fileList
    });
  }


  onKeyPress(event) {
    const eventCode = event.code ? (event.code + ActionConstants.__UNDER_SCORE__ + event.ctrlKey) : event.key + ActionConstants.__UNDER_SCORE__ + event.ctrlKey;
    const buttonStatus = this.state.buttonStatus.find(
      (item) => item.selectedActionIssuerId == this.state.selectedActionIssuerId,
    );
    var disabledNextButton = true;
    if (buttonStatus !== undefined && !buttonStatus.status) {
      disabledNextButton = false;
    }
    switch (eventCode) {
      case KeyConstants.ESCAPE_BUTTON:
      case KeyConstants.ESCAPE_KEY_CODE_BUTTON:
        if (this.state.isError == true || this.state.isWarning == true || this.state.isRequestWarningBanner == true || this.state.isDataUploaded == true) { this.closeBanner(); }
        else {
          this.setCancelResponseBanner();
        }
        break;
      //Exit action with validation banner
      case KeyConstants.CTRL_RIGHTARROW:
      case KeyConstants.CTRL_KEY_CODE_RIGHTARROW:
        if (!disabledNextButton) {
          (this.state.jsonHeadings[this.state.selectedIssuerIndex].reviewScreenKey == "financialAdjustment"
            && (disputeStages.indexOf(this.props.caseStageDetail.disputeStageId) !== -1)
            && (acquirerCodes.indexOf(this.props.acquirerCode) !== -1)
            && this.state.customWarningMessage == "")
            ? this.checkDuplicateFinancials() : this.gotoNextStep();
        }
        event.preventDefault();
        //Go to Prev Step[With validation if available]
        break;
      case KeyConstants.CTRL_LEFTARROW:
      case KeyConstants.CTRL_KEY_CODE_LEFTARROW:
        if (this.state.secondaryButtonText !== '' && this.state.secondaryButtonText !== undefined) {
          this.previousIssuerPage();
        }
        event.preventDefault();
        //Go to next step[With validation if available]
        break;

    }

  }

  //API call to fetch list of operators
  getTransferToList() {
    this.setState({ isTransferListLoading: true });
    return getTransferToList().then((apiResponse) => {
      if (apiResponse.status.statusCode === 2000) {
        const tempTransferList = [];
        for (let i = 0; i < apiResponse.data.length; i++) {
          const selectedObj = {};
          selectedObj.label = apiResponse.data[i].fullName;
          selectedObj.value = apiResponse.data[i].userId;
          tempTransferList.push(selectedObj);
        }
        this.setState({
          transferUserList: tempTransferList,
          isTransferListLoading: false,
        });
      }
    }).catch((error) => {
      this.setState({
        isTransferListLoading: false,
      })
      console.log('Error Occured while fetching List of operators', error);
    });
  }
  /**
  * This method is used for adding merchant message page in writeoff-goodwill and close case action
  * @param {push or pop} operation
  */
  updateJSONHeadingsPage(operation, page, index) {
    switch (operation) {
      case ActionConstants.__PUSH__:
        const arr = Object.assign([], this.state.jsonHeadings);
        const updateIndex = arr.findIndex((issuerActionData) => {
          return issuerActionData.id == ActionConstants.__WRITEOFF_GOODWILL_MERCH_MSG_ID__ || issuerActionData.id == ActionConstants.__CLOSE_CASE_MERCH_MSG_ID;
        });
        if (updateIndex == -1) {
          arr.splice(index, 0, page);
          arr.sort(this.compare);
          this.setState({
            jsonHeadings: arr,
            maxActionIssuerLength: arr.length,
          });
        }
        break;
      case ActionConstants.__POP__:
        const popArray = Object.assign([], this.state.jsonHeadings);
        const popIndex = popArray.findIndex((issuerActionData) => {
          return issuerActionData.id == ActionConstants.__WRITEOFF_GOODWILL_MERCH_MSG_ID__ || issuerActionData.id == ActionConstants.__CLOSE_CASE_MERCH_MSG_ID;
        });
        if (popIndex !== -1) {
          popArray.splice(popIndex, 1);
          this.setState({
            jsonHeadings: popArray,
            maxActionIssuerLength: popArray.length,
          });
        }
        break;
    }
  }

  handleSingleDateChange = (id, value) => {
    let newValue;
    const currentDate = new Date();
    let days;
    const valueFound = false;

    if (valueFound === false) {
      newValue = Object.assign(
        {},
        {
          [id]: { d1: moment(value).format('YYYY-MM-DD') },
        },
      );
    }
    const dt1 = new Date(newValue.pendDate.d1);
    this.getDeadlineDate(newValue.pendDate.d1);
    days = Math.floor((Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) - Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())) / (1000 * 60 * 60 * 24));
    this.setState({
      pendDate: newValue.pendDate.d1,
      daysLeft: days,
      // mydate:newValue.pendDate.d1,
    });
  };

  prePopulateDate = () => {
    const today = new Date();
    const requiredDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 5);
    this.setState({
      pendDate: moment(requiredDate).format('MM/DD/YYYY'),
      daysLeft: 5,
      todayDate: moment(today).format('MM/DD/YYYY'),
    });
  }

  /**
   * This method is used for filter the take action list
   */
  filterTakeActionPageDetailList(pageList) {
    let pageListArray = [];
    const takeActionPageDetail = this.props.takeActionPageDetail;
    for (let i = 0; i < pageList.length; i++) {
      const index = takeActionPageDetail.findIndex(
        (item) => item.takeActionCode === pageList[i].viewCode && pageList[i].description === item.pageName,
      );
      if (index !== -1) {
        pageList[i].seqNo = takeActionPageDetail[index].componentDisplayOrder - 1;
        pageListArray = pageListArray.concat(pageList[i]);
      }
    }
    return pageListArray;
  }
  /**
   * This method is used for setting take action initial state data.
   * @param {props contains selectedAction data} props
   */
  setActionPanelJsonData(props) {
    this.setInitialState();
    const selectedActionId = parseInt(props.selectedActionId);
    this.setState({
      actionViewCode: props.actionViewCode,
      translations: getTranslations(),
      checkBoxStatus: [],
      selectedActionId,
      caseStageId: props.caseStageDetail.caseStageId,
    });

    switch (selectedActionId) {
      // Notify & Request Docs
      case ActionConstants.__NOTIFY_REQUEST_DOCS_ID__:

        const notifyJsonHeadings = this.filterTakeActionPageDetailList(getNotifyAndRequestDocs());
        if (notifyJsonHeadings.length > 0) {
          notifyJsonHeadings[0].secondaryButtonText = ActionConstants.__EMPTY_STRING__;
          this.setState({
            jsonHeadings: notifyJsonHeadings,
            maxActionIssuerLength: notifyJsonHeadings.length,
            attachArray: this.filterTakeActionPageDetailList(getNotifyAndRequestDocsAttachArray()),
            selectedActionIssuerId: notifyJsonHeadings[0].id,
            primaryButtonText: notifyJsonHeadings[0].primaryButtonText,
            submitButtonText: notifyJsonHeadings[0].submitButtonText,
            cancelButtonText: notifyJsonHeadings[0].cancelButtonText,
            closeCaseSubmitPerform: notifyJsonHeadings[0].nextStepPerformSubmit,
            pendDate: undefined,
          });
        }

        break;
      // Request Additional Info
      case ActionConstants.__REQUEST_ADDITIONAL_INFO_ID__:
        const requestAddJsonHeadings = this.filterTakeActionPageDetailList(getAdditionalInfoData());
        if (requestAddJsonHeadings.length > 0) {
          requestAddJsonHeadings[0].secondaryButtonText = ActionConstants.__EMPTY_STRING__;
          this.setState({
            jsonHeadings: requestAddJsonHeadings,
            maxActionIssuerLength: requestAddJsonHeadings.length,
            attachArray: this.filterTakeActionPageDetailList(getAdditionalInfoAttachArray()),
            selectedActionIssuerId: requestAddJsonHeadings[0].id,
            primaryButtonText: requestAddJsonHeadings[0].primaryButtonText,
            submitButtonText: requestAddJsonHeadings[0].submitButtonText,
            cancelButtonText: requestAddJsonHeadings[0].cancelButtonText,
            closeCaseSubmitPerform: requestAddJsonHeadings[0].nextStepPerformSubmit,
          });
        }
        break;
      // Respond to Issuer
      case ActionConstants.__RESPOND_TO_ISSUER_ID__:
      const respondToIssuerJsonHeadings = this.filterTakeActionPageDetailList((this.props.caseNumber !== undefined && this.props.caseNumber.toString().startsWith("5")) ? 
      getProsaActionPaneData() :this.props.caseStageDetail.cardBrandCode === ActionConstants.__VISA_BRAND_CODE__ ? getVisaActionPaneData() : this.props.caseStageDetail.cardBrandCode === ActionConstants.__MASTERCARD_BRAND_CODE__ ?
      getMasterCardActionPaneData() : this.props.caseStageDetail.cardBrandCode === ActionConstants.__AMEX_BRAND_CODE__ ? getAmexActionPaneData() : getActionPaneData()).filter(element => element !== undefined);
      if (respondToIssuerJsonHeadings.length > 0) {
          respondToIssuerJsonHeadings[0].secondaryButtonText = ActionConstants.__EMPTY_STRING__;
          this.setState({
            jsonHeadings: respondToIssuerJsonHeadings,
            maxActionIssuerLength: respondToIssuerJsonHeadings.length,
            attachArray: this.filterTakeActionPageDetailList(getAttachArray()),
            selectedActionIssuerId: respondToIssuerJsonHeadings[0].id,
            primaryButtonText: respondToIssuerJsonHeadings[0].primaryButtonText,
            submitButtonText: respondToIssuerJsonHeadings[0].submitButtonText,
            cancelButtonText: respondToIssuerJsonHeadings[0].cancelButtonText,
            closeCaseSubmitPerform: respondToIssuerJsonHeadings[0].nextStepPerformSubmit,
            pendDate: undefined,
          });
        }
        break;
      // Unable to Defend/pursue
      case ActionConstants.__UNABLE_TO_DEFEND_PURSUE_ID__:
        const unableToDefendJsonHeadings = this.filterTakeActionPageDetailList(getUnableToDefendOrPursueData());
        if (unableToDefendJsonHeadings.length > 0) {
          unableToDefendJsonHeadings[0].secondaryButtonText = ActionConstants.__EMPTY_STRING__;
          this.setState({
            jsonHeadings: unableToDefendJsonHeadings,
            maxActionIssuerLength: unableToDefendJsonHeadings.length,
            attachArray: this.filterTakeActionPageDetailList(this.props.caseStageDetail.cardBrandCode === ActionConstants.__VISA_BRAND_CODE__ ? getVisaDefendOrPursueAttachArray() : this.props.caseStageDetail.cardBrandCode === ActionConstants.__MASTERCARD_BRAND_CODE__ ? getMasterCardDefendOrPursueAttachArray() : getDefendOrPursueAttachArray()),
            selectedActionIssuerId: unableToDefendJsonHeadings[0].id,
            primaryButtonText: unableToDefendJsonHeadings[0].primaryButtonText,
            submitButtonText: unableToDefendJsonHeadings[0].submitButtonText,
            cancelButtonText: unableToDefendJsonHeadings[0].cancelButtonText,
            closeCaseSubmitPerform: unableToDefendJsonHeadings[0].nextStepPerformSubmit,
            pendDate: undefined,
          });
        }
        break;
      // Write off or Goodwill
      case ActionConstants.__WRITEOFF_GOODWILL_ID__:
        let writeOffGoodWillJsonHeadings = this.filterTakeActionPageDetailList(getGoodWillData());
        if (writeOffGoodWillJsonHeadings.length > 0) {
          writeOffGoodWillJsonHeadings[0].secondaryButtonText = ActionConstants.__EMPTY_STRING__;
          this.setState({
            jsonHeadings: writeOffGoodWillJsonHeadings,
            maxActionIssuerLength: writeOffGoodWillJsonHeadings.length,
            attachArray: this.filterTakeActionPageDetailList(this.props.caseStageDetail.cardBrandCode === ActionConstants.__VISA_BRAND_CODE__ ? getVisaGoodWillAttachArray() : this.props.caseStageDetail.cardBrandCode === ActionConstants.__MASTERCARD_BRAND_CODE__ ? getMasterCardGoodWillAttachArray() : getGoodWillAttachArray()),
            selectedActionIssuerId: writeOffGoodWillJsonHeadings[0].id,
            primaryButtonText: writeOffGoodWillJsonHeadings[0].primaryButtonText,
            submitButtonText: writeOffGoodWillJsonHeadings[0].submitButtonText,
            cancelButtonText: writeOffGoodWillJsonHeadings[0].cancelButtonText,
            closeCaseSubmitPerform: writeOffGoodWillJsonHeadings[0].nextStepPerformSubmit,
            pendDate: undefined,
          });
        }
        break;
      case ActionConstants.__CLOSE_CASE_ID__:
        let closeCaseJsonHeadings = this.filterTakeActionPageDetailList(ActionConstants.PIN_DEBIT_ACQUIRERS_LIST.includes(this.props.acquirerCode) ? getTakeActionCloseCasePinDebitAttachArray() : getTakeActionCloseCaseData());
        const closeCaseAttachArray = (ActionConstants.PIN_DEBIT_ACQUIRERS_LIST.includes(this.props.acquirerCode) ? getTakeActionCloseCasePinDebitAttachArray() : getTakeActionCloseCaseAttachArray());
        const jsonHeadingArray = Object.assign([], closeCaseAttachArray);
        if (closeCaseJsonHeadings.length > 0) {
          closeCaseJsonHeadings[0].secondaryButtonText = ActionConstants.__EMPTY_STRING__;
          this.setState({
            jsonHeadings: closeCaseJsonHeadings,
            defaultActionData: closeCaseJsonHeadings,
            maxActionIssuerLength: closeCaseJsonHeadings.length,
            translations: getTranslations(),
            attachArray: this.filterTakeActionPageDetailList(jsonHeadingArray),
            selectedActionIssuerId: closeCaseJsonHeadings[0].id,
            primaryButtonText: closeCaseJsonHeadings[0].primaryButtonText,
            submitButtonText: closeCaseJsonHeadings[0].submitButtonText,
            cancelButtonText: closeCaseJsonHeadings[0].cancelButtonText,
            closeCaseSubmitPerform: closeCaseJsonHeadings[0].nextStepPerformSubmit,
            pendDate: undefined,
          });
        }
        break;
      case ActionConstants.__UPLOAD_DOCUMENT__:
        const uploadDocsConfig = getUploadDocumentData();
        if (uploadDocsConfig.length > 0) {
          uploadDocsConfig[0].secondaryButtonText = "";
          this.setState({
            jsonHeadings: uploadDocsConfig,
            maxActionIssuerLength: uploadDocsConfig.length,
            attachArray: [],
            selectedActionIssuerId: uploadDocsConfig[0].id,
            primaryButtonText: uploadDocsConfig[0].primaryButtonText,
            submitButtonText: uploadDocsConfig[0].submitButtonText,
            cancelButtonText: uploadDocsConfig[0].cancelButtonText,
            closeCaseSubmitPerform: uploadDocsConfig[0].nextStepPerformSubmit,
            pendDate: undefined,

          });
        }

        break;

      case ActionConstants.__TRANSFER_CASE_ID__:
        const transferCaseJsonHeadings = getTakeActionTransferCaseData();
        if (transferCaseJsonHeadings.length > 0) {
          transferCaseJsonHeadings[0].secondaryButtonText = ActionConstants.__EMPTY_STRING__;
          this.setState({
            jsonHeadings: transferCaseJsonHeadings,
            defaultActionData: transferCaseJsonHeadings,
            maxActionIssuerLength: transferCaseJsonHeadings.length,
            translations: getTranslations(),
            attachArray: [],
            selectedActionIssuerId: transferCaseJsonHeadings[0].id,
            primaryButtonText: transferCaseJsonHeadings[0].primaryButtonText,
            cancelButtonText: transferCaseJsonHeadings[0].cancelButtonText,
            submitButtonText: undefined,
            closeCaseSubmitPerform: false,
            pendDate: undefined,
          });
        }
        break;
      // Notify & Request Docs
      case ActionConstants.__UNABLETO_FULFILL_ID__:
        const utfJsonHeadings = this.filterTakeActionPageDetailList((this.props.caseNumber !== undefined && this.props.caseNumber.toString().startsWith("5")) ?
      getProsaUnableToFullfillData():getUnableToFullfillData());
	  if (utfJsonHeadings.length > 0) {
          utfJsonHeadings[0].secondaryButtonText = ActionConstants.__EMPTY_STRING__;
          this.setState({
            jsonHeadings: utfJsonHeadings,
            maxActionIssuerLength: utfJsonHeadings.length,
            attachArray: this.filterTakeActionPageDetailList(getUnableToFulfillAttachArray()),
            selectedActionIssuerId: utfJsonHeadings[0].id,
            primaryButtonText: utfJsonHeadings[0].primaryButtonText,
            submitButtonText: utfJsonHeadings[0].submitButtonText,
            cancelButtonText: utfJsonHeadings[0].cancelButtonText,
            closeCaseSubmitPerform: utfJsonHeadings[0].nextStepPerformSubmit,
            pendDate: undefined,
          });
        }

        break;
      // Respond to Issuer
      case ActionConstants.__RESPOND_TO_CARD_BRAND_ID__:
        const respondToCardJsonHeadings = this.filterTakeActionPageDetailList(this.props.caseStageDetail.cardBrandCode === ActionConstants.__MASTERCARD_BRAND_CODE__ ? getMasterCardBrandActionPaneData() : getDiscoverCardBrandActionPaneData()).filter(element => element !== undefined);
        if (respondToCardJsonHeadings.length > 0) {
          respondToCardJsonHeadings[0].secondaryButtonText = ActionConstants.__EMPTY_STRING__;
          this.setState({
            jsonHeadings: respondToCardJsonHeadings,
            maxActionIssuerLength: respondToCardJsonHeadings.length,
            attachArray: this.filterTakeActionPageDetailList(getCardBrandAttachArray()),
            selectedActionIssuerId: respondToCardJsonHeadings[0].id,
            primaryButtonText: respondToCardJsonHeadings[0].primaryButtonText,
            submitButtonText: respondToCardJsonHeadings[0].submitButtonText,
            cancelButtonText: respondToCardJsonHeadings[0].cancelButtonText,
            closeCaseSubmitPerform: respondToCardJsonHeadings[0].nextStepPerformSubmit,
            pendDate: undefined,
          });
        }
        break;
        
        //Request Issuer Document
         case ActionConstants.__REQUEST_ISSUER_DOCUMENT_ID__:
          const ridJsonHeadings = getEVOCardRIDActionPaneData();
          if (ridJsonHeadings.length > 0) {
            ridJsonHeadings[0].secondaryButtonText = ActionConstants.__EMPTY_STRING__;
            this.setState({
              jsonHeadings: ridJsonHeadings,
              maxActionIssuerLength: ridJsonHeadings.length,
              selectedActionIssuerId: ridJsonHeadings[0].id,
              primaryButtonText: ridJsonHeadings[0].primaryButtonText,
              submitButtonText: ridJsonHeadings[0].submitButtonText,
              cancelButtonText: ridJsonHeadings[0].cancelButtonText,
              closeCaseSubmitPerform: false,
            });
          }
        break;
      // pcf
      case ActionConstants.__PURSUE_CASE_FILLING_ID__:
        let pcfJsonHeadings;
        if (this.props.caseNumber && this.props.caseNumber.toString().startsWith("5")) {
          pcfJsonHeadings = (this.props.acquirerCode === 'EMD') ? getEvoCardPCFActionPaneData() : getProsaCardPCFActionPaneData();
        } else if (this.props.caseStageDetail.cardBrandCode === ActionConstants.__MASTERCARD_BRAND_CODE__) {
            pcfJsonHeadings = getMasterCardPCFActionPaneData();
        } else if (this.props.caseStageDetail.cardBrandCode === ActionConstants.__VISA_BRAND_CODE__) {
            pcfJsonHeadings = getVisaCardPCFActionPaneData();
        } else {
            pcfJsonHeadings = getGoodFaithPCFActionPaneData();
        }
        if (pcfJsonHeadings.length > 0) {
          pcfJsonHeadings[0].secondaryButtonText = ActionConstants.__EMPTY_STRING__;
          this.setState({
            jsonHeadings: pcfJsonHeadings,
            maxActionIssuerLength: pcfJsonHeadings.length,
            attachArray: getPCFAttachArray(),
            selectedActionIssuerId: pcfJsonHeadings[0].id,
            primaryButtonText: pcfJsonHeadings[0].primaryButtonText,
            submitButtonText: pcfJsonHeadings[0].submitButtonText,
            cancelButtonText: pcfJsonHeadings[0].cancelButtonText,
            closeCaseSubmitPerform: pcfJsonHeadings[0].nextStepPerformSubmit,
            pendDate: undefined,
          });
        }
        break;
    }
  }


  fetchLedgers(acquirerCode, merchantRegionCode) {
    this.setState({
      isFetchingLedger: true,
    })
    fetchLedgers(acquirerCode, merchantRegionCode).then((response) => {
      let ledgers = [];
      response.data.forEach((listItem) => {
        ledgers = ledgers.concat({
          value: `${listItem.glAccountNumber}: ${listItem.glAccountDescription}`,
          text: `${listItem.glAccountNumber}: ${listItem.glAccountDescription}`,
          appearDefault: false,
        });
      });
      this.setState({
        ledgers,
        isFetchingLedger: false,
      });
    }).catch((error) => {
      this.setState({
        isFetchingLedger: false,
      })
      console.log('Error Occured while fetching Ledger values', error);
    });
  }
 setAdjustmentLedgerForAcceptance=(acquirerCode)=>{
   let adjustmentLedger = [{
     amount: updatedAcceptanceAmount,
     glAccountNumber: evoAcquirerCodes.includes(acquirerCode)? "14016": "1110",
     ledger: "Miscellaneous (Exception cases)",
     type: "CREDIT"
   }, {
     amount: updatedAcceptanceAmount,
     glAccountNumber: evoAcquirerCodes.includes(acquirerCode)? "24105" : "1320",
     ledger: "Merchant GL",
     type: "DEBIT"
   }];
  return JSON.stringify(adjustmentLedger);
 }
  getfinancialAdjustmentData(caseNumber, actionViewCode,acquirerCode) {
    this.setState({
      isFinancialAdjustmentDataLoading: true,
    })
    getLedgersForCase(caseNumber, actionViewCode,acquirerCode).then((response) => {
      const financialData = response.data.financialAdjustData;
      let adjustmentLedger = response.data.adjustmentLedger;
      apiLedgerData = adjustmentLedger;
      if(actionViewCode == 'RTI' && this.props.caseStageDetail.cardBrandCode == 'VI' && (this.props.caseStageDetail.disputeStageName == 'Incoming Pre-Arbitration' || this.props.caseStageDetail.disputeStageName == 'Incoming Pre-Compliance')){
        financialData.partialChargebackIndicator = "1";/*Sets Partial Chargeback to Y*/
        showApiLedgerFlag = false;
      }
      else{
        showApiLedgerFlag = true;
      }
      financialData.balanceAmount = 0;
      financialData.caseAmountCurrency = financialData.caseAmount.currency;

      this.setState({
        financialData,
        adjustmentLedger,
        isFinancialAdjustmentDataLoading: false,
      });
    }).catch((error) => {
      const financialData = [];
      if(actionViewCode == 'RTI' && this.props.caseStageDetail.cardBrandCode == 'VI' && this.props.caseStageDetail.disputeStageName == 'Incoming Pre-Arbitration' && error.response.status == 404){
        financialData.partialChargebackIndicator = "1";/*Sets Partial Chargeback to Y*/
        showApiLedgerFlag = false;
      }
      else{
        showApiLedgerFlag = true;
      }
      this.setState({
        financialData,
        isFinancialAdjustmentDataLoading: false,
      })
      console.log('Error Occured while fetching Ledger values', error);
    });
  }

  getAdjustFinancialDataForSubmit() {
    let financialData = transformFinancialAdjustmentDataSubmit(this.props.adjustFinancialsData.data, this.props.acquirerCode);
    let validfinancialData = financialData.data && financialData.data.filter((ledgerList)=> {return ledgerList.ledger!== undefined});
    if(validfinancialData)
    financialData.data = validfinancialData;
    return financialData;
  }

  getAdjustFinancialDataForReview() {
    let financialData = transformFinancialAdjustmentDataReview(this.props.adjustFinancialsData);
    let validfinancialData = financialData.data && financialData.data.filter((ledgerList)=> {return ledgerList.ledger!== undefined});
    if(validfinancialData)
    financialData.data = validfinancialData;
    return financialData;
  }

  /**
   * This method is used for selecting round button index on action issuer pages.
   * @param {*} selectedIssuerIndex
   */
  onPageChange(selectedIssuerIndex) {
    this.setState({ 
      customWarningMessage: "" ,
      isFinancialAdjustmentWarning: false,
      merchantMsgPresent : true,
      isAnnex19Present: false,
     });
    if (selectedIssuerIndex <= this.state.jsonHeadings.length - 1) {
      const id = this.state.jsonHeadings[selectedIssuerIndex].id;
      if (this.props.adjustFinancialsData !== undefined || (this.state.issuerActionData !== undefined && this.state.issuerActionData.length > 0 && this.state.issuerActionData[selectedIssuerIndex - 1] !== undefined)) {
        var representmentAmount = [];
        var ledgerData = transformFinancialAdjustmentDataReview(this.props.adjustFinancialsData).data;
        if ((this.props.caseStageDetail.disputeStageName == 'Chargeback' && this.props.caseStageDetail.cardBrandCode == 'DI') || this.props.caseStageDetail.cardBrandCode == 'MC' || this.props.caseStageDetail.cardBrandCode == 'VI') {
          representmentAmount[0] = ledgerData.length > 0 ? 0 : undefined;
          for (let i = 0; i < ledgerData.length; i++) {
            if ((ledgerData[i].debit && ledgerData[i].debit !== "--") && ledgerData[i].ledger && (ledgerData[i].ledger.indexOf('1120') !== -1 || ledgerData[i].ledger.indexOf('24105') !== -1 )) {
              representmentAmount[0] = representmentAmount[0] + parseFloat(ledgerData[i].debit !== "--" ? (Math.round(ledgerData[i].debit * 100) / 100).toFixed(2) : 0);
            }
          }
          this.setState({
            glBankAmount: representmentAmount
          })
        }
        const selectedActionIssuerId = this.state.jsonHeadings[selectedIssuerIndex].id;
        let issuerActionData = [...this.state.issuerActionData];
        let isFinancialPage = this.state.selectedIssuerIndex == 0 && this.state.jsonHeadings[this.state.selectedIssuerIndex].reviewScreenKey == 'financialAdjustment' ? true : false;
        const updateIndex = this.state.issuerActionData.findIndex((issuerActionData) => {
          return issuerActionData.selectedActionIssuerId == selectedActionIssuerId;
        });
        if (isFinancialPage) {
          if (issuerActionData && updateIndex != -1 && issuerActionData[updateIndex] && issuerActionData[updateIndex].text !== undefined && ((this.props.caseStageDetail.cardBrandCode == "DI" && this.props.caseStageDetail.disputeStageName == "Chargeback") || (this.props.caseStageDetail.cardBrandCode == 'VI' && (this.props.caseStageDetail.disputeStageName == 'Incoming Pre-Arbitration' || this.props.caseStageDetail.disputeStageName == 'Incoming Pre-Compliance')))) {
            issuerActionData[updateIndex].text = representmentAmount[0];
            if (this.state.merchantRate) {
              representmentAmount[0] = representmentAmount[0] * this.state.merchantRate;
            }

            this.setState({
              representmentAmount,
              issuerActionData,
            });
          } else {
            this.setState({
              representmentAmount
            });
          }
        }
        this.setIssuerPageIndexes(selectedIssuerIndex, id);
        this.setState({
          showComponent: true,
          showText: true,
          textId: selectedIssuerIndex,
          isActive: true,
          secondaryButtonText: this.state.jsonHeadings[selectedIssuerIndex].secondaryButtonText,
          primaryButtonText: this.state.jsonHeadings[selectedIssuerIndex].primaryButtonText,
          submitButtonText: this.state.jsonHeadings[selectedIssuerIndex].submitButtonText,
          cancelButtonText: this.state.jsonHeadings[selectedIssuerIndex].cancelButtonText,
          selectedActionIssuerId: id,
          todayDate: this.state.pendDate,
        });
      }
    } else if (this.state.selectedActionId == ActionConstants.__TRANSFER_CASE_ID__) {
      this.setState({
        isLoading: true,
        isSubmitButtonClicked: true,
      }, () => {
        this.props.getSubmitActionStatus(true);
      })
      transferCase(this.state.transferCase).then((res) => {
        if (res.status.statusCode == 2000 || res.status.statusCode == 200) {
          this.setsubmitResponseBanner();
        }
      }).catch((res) => {
        this.setState({
          bannerResponseMessage: `${this.props.submitActionOption} failed for the case number :`,
          isDataUploaded: false,
          isError: true,
          commentText: '',
          isLoading: false,
          isSubmitButtonClicked: false,
        }, () => {
          this.props.getSubmitActionStatus(false);
        });
      });
    } else if (this.state.selectedActionId == ActionConstants.__UPLOAD_DOCUMENT__) {
      this.setState({
        isLoading: true,
        isSubmitButtonClicked: true,
      }, () => {
        this.props.getSubmitActionStatus(true);
      });

      const fileData = {};
      fileData['cardBrandCode'] = this.props.caseStageDetail.cardBrandCode;
      fileData['regionCode'] = this.props.merchantRegionCode;
      fileData['uploadFileList'] = this.state.uploadFileList.map(file => {
        let data = file.response.data;
        data.documentType = file.selectedDoc.value;
        data.documentTypeId = file.selectedDoc.id;
        return data;
      });

      return attachDocuments(fileData, this.props.caseNumber, this.props.caseStageDetail.caseStageId, this.props.acquirerCode).then((res) => {
        if (res.status.statusCode == 2000 || res.status.statusCode == 200) {
          this.setsubmitResponseBanner();
          this.setState({
            uploadFileList: [],
          }, () => {
            this.props.getSubmitActionStatus(false);
          });

        }
      }).catch((error) => {
        console.log('Error occured while attaching the documents', error);
        this.setState({
          bannerResponseMessage: `${this.props.submitActionOption} failed for the case number :`,
          isDataUploaded: false,
          isError: true,
          isLoading: false,
          isSubmitButtonClicked: false,
          uploadFileList: [],
        }, () => {
          this.props.getSubmitActionStatus(false);
        });
      });
    } else if (this.state.selectedActionId == ActionConstants.__REQUEST_ISSUER_DOCUMENT_ID__){
      this.setState({
        isLoading: true,
        isSubmitButtonClicked: true,
      }, () => {
        this.props.getSubmitActionStatus(true);
      });
      const resp = {};
      resp.disputeReasonCode = this.getReasonCode(this.props.caseStageDetail.disputeReasonCode);
      resp.caseNumber = this.props.caseNumber;
      resp.caseStageId  = this.state.caseStageId;
      resp.responseReasonCode = this.state.actionDescriptionList[0].finalSelectionList[0].value;
      resp.disputeStageId = this.props.caseStageDetail.disputeStageId;
      resp.userId = `${this.props.userId}`;
      resp.actionCode = this.state.actionViewCode;
      resp.acquirerCode = this.props.acquirerCode;
      resp.reviewComment = {
        comment : {
          commentText : this.state.issuerActionData[0].note === '' ? '  ' : this.state.issuerActionData[0].note
        }
      }
      resp.cardBrandCode = this.props.caseStageDetail.cardBrandCode;
      submitTakeActionResponse(resp,this.props.caseNumber).then((res) => {
        if (res.status.statusCode == 2000 || res.status.statusCode == 200) {
          this.setsubmitResponseBanner();
        }
      }).catch((res) => {
        this.setState({
          bannerResponseMessage: `${this.props.submitActionOption} failed for the case number :`,
          isDataUploaded: false,
          isError: true,
          commentText: '',
          isLoading: false,
          isSubmitButtonClicked: false,
        }, () => {
          this.props.getSubmitActionStatus(false);
        });
      });

    }
    document.getElementById("ActionPane").scrollIntoView({behavior:"smooth", block: "start", inline:"start"});
    let merchantMessageNew = this.state.merchantMessage;
    let merchantMessageTemp = this.state.merchantMessageTemp.map(item => {
      if(item.desc == "Choose One" && item.title == "Letter Template") {
        let newItem = {
          desc: "No advice generated",
          title: item.title
        }
        return newItem;
      } else {
        return item;
      }
    })
    setTimeout(() => {
      if (this.state.skipNotifyMerchant) {
        this.setState({
          merchantMessage: {
            ...merchantMessageNew,
            letterTemplateLanguageId: VITE_DEFAULT_LETTER_TEMPLATE_LANGUAGE_ID,
          },
          merchantMessageTemp

        })
      }
    }, 150)
  }

  preparePostDataForProsaPCFSCB(state){
    if (state.languageIndCode == 'EN') {
      state.merchantMessage.merchPrefLangLetterMessage = '';
    }
    const resp = {};
    const comment = state.comment;
    for (let i = 0; i < state.jsonHeadings.length; i++) {
      const reviewScreenKey = state.jsonHeadings[i].reviewScreenKey;
      switch (reviewScreenKey) {
        case ActionConstants.__ACCEPT_LIABILITY_KEY__:
          resp[ActionConstants.__ACCEPT_LIABILITY_KEY__] = getLiabilitySubmitData(state.issuerActionData);
          break;
        case ActionConstants.__WRITE_OFF_REASON_KEY__:
          resp[ActionConstants.__WRITE_OFF_REASON_KEY__] = getWriteOffReasonSubmitData(state.issuerActionData);
          break;
        case ActionConstants.__FINANCIAL_ADJUSTMENT_KEY__:
         // resp[ActionConstants.__FINANCIAL_ADJUSTMENT_KEY__] = this.getAdjustFinancialDataForSubmit();
          break;
        case ActionConstants.__MERCHANT_MESSAGE_KEY__:
        //  resp[ActionConstants.__MERCHANT_MESSAGE_KEY__] = merchantMessage;
          break;
        case ActionConstants.__REPRESENTMENT_QUESTION_KEY__:
          resp[ActionConstants.__REPRESENTMENT_QUESTION_KEY__] = getQuestionSubmitData(state.issuerActionData, this.props.caseDocuments.issuerImageData.orderOfSelectedPages, this.props.caseStageDetail.cardBrandCode, state.visaQuestionnaire, this.props.caseStageDetail.disputeStageName, this.state.actionViewCode, this.props.disputeCurrencyCode, this.props.merchantCurrencyCode, this.props.transactionDate);
          break;
        case ActionConstants.__CLOSE_CASE_KEY__:
          resp[ActionConstants.__CLOSE_CASE_KEY__] = getCloseCaseSubmitData(state.issuerActionData);
          resp.recordCaseRuling = getRecordCaseRulingSubmitData(state.checkBoxStatus);
          break;
        case ActionConstants.__REVIEW_ACTION_KEY__:
          resp[ActionConstants.__REVIEW_ACTION_KEY__] = {
            comment,
          };
          break;

      }
      resp.actionCode = this.state.actionViewCode;
      resp.caseStageId = this.state.caseStageId;
      resp.userId = this.state.userId;
      
    }
    return resp;

  }

  prepareProsaPostDataSCBCC(state){
    if (state.languageIndCode == 'EN') {
      state.merchantMessage.merchPrefLangLetterMessage = '';
    }

    const merchantMessage = getMerchantMessageSubmitData(state.merchantMessage, this.props.caseDocuments.merchantImageData.orderOfSelectedPages);
    const resp = {};
    const comment = state.comment;
    for (let i = 0; i < state.jsonHeadings.length; i++) {
      const reviewScreenKey = state.jsonHeadings[i].reviewScreenKey;
      switch (reviewScreenKey) {
        case ActionConstants.__ACCEPT_LIABILITY_KEY__:
          resp[ActionConstants.__ACCEPT_LIABILITY_KEY__] = getLiabilitySubmitData(state.issuerActionData);
          break;
        case ActionConstants.__WRITE_OFF_REASON_KEY__:
          resp[ActionConstants.__WRITE_OFF_REASON_KEY__] = getWriteOffReasonSubmitData(state.issuerActionData);
          break;
        case ActionConstants.__FINANCIAL_ADJUSTMENT_KEY__:
          resp[ActionConstants.__FINANCIAL_ADJUSTMENT_KEY__] = this.getAdjustFinancialDataForSubmit();
          break;
        case ActionConstants.__MERCHANT_MESSAGE_KEY__:
          resp[ActionConstants.__MERCHANT_MESSAGE_KEY__] = merchantMessage;
          break;
        case ActionConstants.__REPRESENTMENT_QUESTION_KEY__:
          resp[ActionConstants.__REPRESENTMENT_QUESTION_KEY__] = getQuestionSubmitData(state.issuerActionData, this.props.caseDocuments.issuerImageData.orderOfSelectedPages, this.props.caseStageDetail.cardBrandCode, state.visaQuestionnaire, this.props.caseStageDetail.disputeStageName, this.state.actionViewCode, this.props.disputeCurrencyCode, this.props.merchantCurrencyCode, this.props.transactionDate);
          break;
        case ActionConstants.__CLOSE_CASE_KEY__:
          resp[ActionConstants.__CLOSE_CASE_KEY__] = getCloseCaseSubmitData(state.issuerActionData);
          resp.recordCaseRuling = getRecordCaseRulingSubmitData(state.checkBoxStatus);
          break;
        case ActionConstants.__REVIEW_ACTION_KEY__:
          resp[ActionConstants.__REVIEW_ACTION_KEY__] = {
            comment,
          };
          break;

      }
      resp[ActionConstants.__CLOSE_CASE_KEY__]={
        comment
      }
      resp.actionCode = 'CC';
      resp.caseStageId = this.state.caseStageId;
      resp.userId = this.state.userId;
      resp.prosaCloseCasePCFSCB =true ; 
    }
    return resp;
  }

  preparePostData(state) {
    if (state.languageIndCode == 'EN') {
      state.merchantMessage.merchPrefLangLetterMessage = '';
    }
    const merchantMessage = getMerchantMessageSubmitData(state.merchantMessage, this.props.caseDocuments.merchantImageData.orderOfSelectedPages);
    const resp = {};
    const comment = state.comment;
    for (let i = 0; i < state.jsonHeadings.length; i++) {
      const reviewScreenKey = state.jsonHeadings[i].reviewScreenKey;
      switch (reviewScreenKey) {
        case ActionConstants.__ACCEPT_LIABILITY_KEY__:
          resp[ActionConstants.__ACCEPT_LIABILITY_KEY__] = getLiabilitySubmitData(state.issuerActionData, state.checkBoxStatus);
          break;
        case ActionConstants.__WRITE_OFF_REASON_KEY__:
          resp[ActionConstants.__WRITE_OFF_REASON_KEY__] = getWriteOffReasonSubmitData(state.issuerActionData);
          break;
        case ActionConstants.__FINANCIAL_ADJUSTMENT_KEY__:
          resp[ActionConstants.__FINANCIAL_ADJUSTMENT_KEY__] = this.getAdjustFinancialDataForSubmit();
          break;
        case ActionConstants.__MERCHANT_MESSAGE_KEY__:
          resp[ActionConstants.__MERCHANT_MESSAGE_KEY__] = merchantMessage;
          break;
        case ActionConstants.__REPRESENTMENT_QUESTION_KEY__:
          resp[ActionConstants.__REPRESENTMENT_QUESTION_KEY__] = getQuestionSubmitData(state.issuerActionData, this.props.caseDocuments.issuerImageData.orderOfSelectedPages, this.props.caseStageDetail.cardBrandCode, state.visaQuestionnaire, this.props.caseStageDetail.disputeStageName, this.state.actionViewCode, this.props.disputeCurrencyCode, this.props.merchantCurrencyCode, this.props.transactionDate);
          break;
        case ActionConstants.__CLOSE_CASE_KEY__:
          resp[ActionConstants.__CLOSE_CASE_KEY__] = getCloseCaseSubmitData(state.issuerActionData);
          resp.recordCaseRuling = getRecordCaseRulingSubmitData(state.checkBoxStatus);
          break;
        case ActionConstants.__REVIEW_ACTION_KEY__:
          resp[ActionConstants.__REVIEW_ACTION_KEY__] = {
            comment,
          };
          break;

      }
      resp.actionCode = this.state.actionViewCode;
      resp.caseStageId = this.state.caseStageId;
      resp.userId = this.state.userId;
    }
    return resp;
  }

  closeActionForIssuerAction = () => {
    this.setState({
      isVisible: false,
      issuerActionData: [],
    });
    this.props.resetActionPane();
    this.props.resetNestedFieldSelectorData();
  }

  closeActionPane = () => {
    const actionPanelData = getActionPaneData();
    // Clear user modified data on click on cancel.
    this.setState({
      isVisible: false,
      issuerActionData: [],
      merchantImageData: [],
      issuerImageData: [],
      actionDescriptionList: [],
      buttonStatus: [],
      checkBoxStatus: [],
      ledgers: [],
      selectedIssuerIndex: 0,
      primaryButtonText: actionPanelData[0].primaryButtonText,
      cancelButtonText: actionPanelData[0].cancelButtonText,
      secondaryButtonText: '',
      merchantMessage: {
        documentsForMerchant: [
          {
            base64EncodedImage: 'string',
            imageFormat: 'string',
          },
        ],
        letterMessage: '',
        merchPrefLangLetterMessage: '',
        letterTemplateLanguageId: 0,
        merchantDocumentsProvided: false,
        returnToPDRFlag:false,
        reasonForAdditionalReview: '',
      },
      reasonForAdditionalReviewLength:0,
      merchantMessageTemp: [],
      messageType: {
        value: '',
        text: '',
      },
      letterTemplate: {
        value: 'choose-one',
        text: 'Choose One',
      },
      englishMessage: '',
      otherMessage: '',
      predefMessageData: {
        englishLanguage: '',
        preferredLanguage: '',
      },
      jsonHeadings: actionPanelData,
    });

    this.props.resetActionPane();
    this.props.closeNotification();
    this.props.resetNestedFieldSelectorData();
  }


  setCancelResponseBanner() {
    document.getElementById('1_btn_clear') && document.getElementById('1_btn_clear').blur();
    this.setState({
      isWarning: true,
    });
  }


  submitAction = () => {
    this.setState({
      isSubmitButtonClicked: true,
      isLoading: true,
    }, () => {
      this.props.getSubmitActionStatus(true);
    })
    document.getElementById('1_btn_apply') && document.getElementById('1_btn_apply').blur();
    document.getElementById('1_btn_next') && document.getElementById('1_btn_next').blur();

    
    if(this.props.submitActionOption === 'Pursue Case Filing' && this.props.acquirerCode === 'MXP' && this.props.caseStageDetail.disputeStageId == 24){
      
      submitTakeActionResponse(this.prepareProsaPostDataSCBCC(this.state), this.props.caseNumber).then((res) => {
        if (res.status && (res.status.statusCode == 2000 || res.status.statusCode == 200)) {
          this.callPCFActionForProsaSCB();
          this.setsubmitResponseBanner();
          if (this.props.submitActionOption === 'Close Case') {
            this.props.setCaseStatus('Close');
          }
          this.closeActionForIssuerAction();
          if(this.state.warningType !== '' && this.state.caseAdjustment !== ''){
            logWarningEvent(this.state.warningType, this.state.caseAdjustment, this.props.caseNumber);
          }
          this.setState({
            isVisible: false,
            issuerActionData: [],
            isLoading: false,
            isSubmitButtonClicked: false,
          }, () => {
            this.props.getSubmitActionStatus(false);
          });
        } if (res.status.statusCode == 2007 && res.data == 'Failed') {
          this.setState({
            bannerResponseMessage: 'Please Select another Date.',
            isRequestWarningBanner: true,
            isDataUploaded: false,
            isError: false,
            commentText: '',
            isVisible: true,
            isLoading: false,
            isSubmitButtonClicked: false,
          }, () => {
            this.props.getSubmitActionStatus(false);
          });
        }
      }).catch((res) => {
        if (this.props.submitActionOption === 'Close Case' && res.response && (res.response.status == 4000 || res.response.status == 400)) {
          this.setState({
            bannerResponseMessage: 'This Case is already closed :',
            isDataUploaded: false,
            isError: true,
            commentText: '',
            isVisible: true,
            isLoading: false,
            isSubmitButtonClicked: false,
          }, () => {
            this.props.getSubmitActionStatus(false);
          });
        } else {
          const selectedActionId = parseInt(this.props.selectedActionId);
          const selectedOptionvalue = this.props.submitActionOption;
          this.setState({
            bannerResponseMessage: this.props.selectedOptionvalue === 'Close Case' ? 'Close case operation failed for the case number :' : `Send ${selectedActionId == ActionConstants.__RESPOND_TO_ISSUER_ID__ ? 'Response to Issuer' : selectedOptionvalue} failed for the case number :`,
            isDataUploaded: false,
            isError: true,
            commentText: '',
            isLoading: false,
            isSubmitButtonClicked: false,
          }, () => {
            this.props.getSubmitActionStatus(false);
          });
        }
      });
    } else {
      submitTakeActionResponse(this.preparePostData(this.state), this.props.caseNumber).then((res) => {
      if (res.status && (res.status.statusCode == 2000 || res.status.statusCode == 200)) {
        this.setsubmitResponseBanner();
        if (this.props.submitActionOption === 'Close Case') {
          this.props.setCaseStatus('Close');
        }
        this.closeActionForIssuerAction();
        if(this.state.warningType !== '' && this.state.caseAdjustment !== ''){
          logWarningEvent(this.state.warningType, this.state.caseAdjustment, this.props.caseNumber);
        }
        this.setState({
          isVisible: false,
          issuerActionData: [],
          isLoading: false,
          isSubmitButtonClicked: false,
        }, () => {
          this.props.getSubmitActionStatus(false);
        });
      } if (res.status.statusCode == 2007 && res.data == 'Failed') {
        this.setState({
          bannerResponseMessage: 'Please Select another Date.',
          isRequestWarningBanner: true,
          isDataUploaded: false,
          isError: false,
          commentText: '',
          isVisible: true,
          isLoading: false,
          isSubmitButtonClicked: false,
        }, () => {
          this.props.getSubmitActionStatus(false);
        });
      }
    }).catch((res) => {
      if (this.props.submitActionOption === 'Close Case' && res.response && (res.response.status == 4000 || res.response.status == 400)) {
        this.setState({
          bannerResponseMessage: 'This Case is already closed :',
          isDataUploaded: false,
          isError: true,
          commentText: '',
          isVisible: true,
          isLoading: false,
          isSubmitButtonClicked: false,
        }, () => {
          this.props.getSubmitActionStatus(false);
        });
      } else {
        const selectedActionId = parseInt(this.props.selectedActionId);
        const selectedOptionvalue = this.props.submitActionOption;
        this.setState({
          bannerResponseMessage: this.props.selectedOptionvalue === 'Close Case' ? 'Close case operation failed for the case number :' : `Send ${selectedActionId == ActionConstants.__RESPOND_TO_ISSUER_ID__ ? 'Response to Issuer' : selectedOptionvalue} failed for the case number :`,
          isDataUploaded: false,
          isError: true,
          commentText: '',
          isLoading: false,
          isSubmitButtonClicked: false,
        }, () => {
          this.props.getSubmitActionStatus(false);
        });
      }
    });}
  }

  setRequestAdditionalWarningBanner() {
    if (this.state.isRequestWarningBanner) {
      return (
        <div>
           <ImagePortal>
          <ResponseBanner
            titleStyle={{ color: 'light-green' }}
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title="Deadline Date Exceeds Card Brand Timeframe"
            description={this.state.bannerResponseMessage}
            type="danger"
            isPrimarSecondaryButtonCombo
            onClose={this.closeBanner}
            cancelButtonText="DISMISS"
            primaryButtonText="PICK ANOTHER DATE"
            primaryButtonActionValue={ActionConstants.__EMPTY_STRING__}
            primaryButtonAction={this.closeBanner}
            secondaryButtonAction={this.closeBanner}
          />
           </ImagePortal>
        </div>
      );
    }
  }
  getCardBrandDisputeActionDescriptions(props) {
    let respondToStageId = props.caseStageDetail.disputeStageId ? props.caseStageDetail.disputeStageId : null;
    let actionObject = { 
      cardBrandCode: getCardBrandCode(props.acquirerCode, props.caseStageDetail.cardBrandCode), 
      respondToStageId, 
      takeActionCode: props.actionViewCode,
      isCreditChargebackInd: props.isCreditChargebackInd
    };
    getActionDescriptions('api/v1/disputecasedata/actions/description', actionObject).then((res) => {
      if (res.status && (res.status.statusCode == 2000 || res.status.statusCode == 200)) {
        var issuerId;
        issuerId = props.actionViewCode === __PCF_ACTION_CODE__ || props.actionViewCode === 'RTI' || props.actionViewCode === 'RTCB' ? 2 : props.actionViewCode === 'UTF' ? 40 : props.actionViewCode === 'WOG' ? 24 : props.actionViewCode === 'UTD' ? 14 : -1;
        this.setSelectionList(res.data, issuerId);
        this.setState({
          isLoadingActionDescriptions: false,
        })
      }
    }).catch((res) => {
      console.log('Error Occured while fetching action description', res);
      this.setState({
        isLoadingActionDescriptions: false,
      })

    });
    this.setState({
      selectedActionId: props.selectedActionId,
    });
  }

  getCardBrandAnnex19Descriptions(props) {
    getRIDResponseReasonCodeDescription(`api/v1/disputecasedata/reasoncode/cardbrand/${getCardBrandCode(props.acquirerCode, props.caseStageDetail.cardBrandCode)}` ).then((res) => {
      if (res.status && (res.status.statusCode == 2000 || res.status.statusCode == 200)) {
         this.setSelectionList(res.data, ActionConstants.__REQUEST_ISSUER_DOCUMENT__);
        this.setState({
          isLoadingActionDescriptions: false,
        })
      }
    }).catch((res) => {
      console.log('Error Occured while fetching response reasoncode description', res);
      this.setState({
        isLoadingActionDescriptions: false,
      })
    });
    this.setState({
      selectedActionId: props.selectedActionId,
    });
  }

  getPrimaryRuleViolationList() {
    getSecondaryCodeList(`api/v1/disputecasedata/questionnaire/${this.props.caseStageDetail.cardBrandCode}/violations`).then((res) => {
      if (res.status && (res.status.statusCode == 2000 || res.status.statusCode == 200)) {
        let selectionList = [...res.data];
        this.setPrimaryViolationRules(selectionList);
        this.setState({
          isPrimaryRulesLoading: false,
        })
      }
    }).catch((res) => {
      this.setState({
        isPrimaryRulesLoading: false,
      })
      console.log('Error Occured while fetching response reasoncode description', res);
    });
  }

  getCasefilingTypes(cardBrandCode) {
    getSecondaryCodeList(`api/v1/disputecasedata/casefilingtype/cardbrand/${cardBrandCode}`).then((res) => {
      if (res.status && (res.status.statusCode == 2000 || res.status.statusCode == 200)) {
        let selectionList = [...res.data];
        const caseFilingTypes = [];
        for (let i = 0; i < selectionList.length; i++) {
          const selectedObj = {};
          selectedObj.text = selectionList[i].text;
          selectedObj.value = selectionList[i].value;
          caseFilingTypes.push(selectedObj);
        }
        this.setState({
          caseFilingTypes,
          isCaseFilingTypesLoading: false,
        });
      }
    }).catch((res) => {
      console.log('Error Occured while fetching response case filing types', res);
      this.setState({
        isCaseFilingTypesLoading: false,

      })
    });
  }

  getGoodFaithTypes() {
    getSecondaryCodeList(`api/v1/disputecasedata/goodfaith/type`).then((res) => {
      if (res.status && (res.status.statusCode == 2000 || res.status.statusCode == 200)) {
        let selectionList = [...res.data];
        const goodFaithTypes = [];
        for (let i = 0; i < selectionList.length; i++) {
          const selectedObj = {};
          selectedObj.text = selectionList[i].stageName;
          selectedObj.value = selectionList[i].stageId;
          goodFaithTypes.push(selectedObj);
        }
        this.setState({
          goodFaithTypes,
          isGoodFaithLoading: false,
        });
      }
    }).catch((res) => {
      this.setState({
        isGoodFaithLoading: false,
      })
      console.log('Error Occured while fetching response good faith types', res);
    });
  }

  setPrimaryViolationRules(selectionList) {
    const primaryRuleViolationList = [];
    for (let i = 0; i < selectionList.length; i++) {
      const selectedObj = {};
      selectedObj.text = selectionList[i].violationDescription;
      selectedObj.value = selectionList[i].violationCode;
      primaryRuleViolationList.push(selectedObj);
    }
    this.setState({
      primaryRuleViolationList,
    });
  }

 getReasonCode(disputeReasonCode) {
    return disputeReasonCode ? disputeReasonCode.trim() : '' ;
  }
  
  getResponseReasonDescription(props) {
    getSecondaryCodeList(`api/v1/disputecasedata/reasoncode/${this.getReasonCode(props.caseStageDetail.disputeReasonCode)}/cardbrand/${props.caseStageDetail.cardBrandCode}`).then((res) => {
      if (res.status && (res.status.statusCode == 2000 || res.status.statusCode == 200)) {
        let selectionList = [...res.data];
        this.setResponseReasonList(selectionList);
      }
    }).catch((res) => {
      console.log('Error Occured while fetching response reasoncode description', res);
    });
  }


  setResponseReasonList(selectionList) {
    const secondaryDropDownList = [];
    for (let i = 0; i < selectionList.length; i++) {
      const selectedObj = {};
      selectedObj.text = selectionList[i].responseReasonDescription;
      selectedObj.value = selectionList[i].responseReasonCode;
      secondaryDropDownList.push(selectedObj);
    }
    this.setState({
      secondaryDropDownList,
    });
  }

  /** Image data for scheme and merchant */
  getCaseNumberImageData(caseNumber, actionCode=-1) {
    let documentTypeId = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 16, 17, 18];
    this.props.fetchDocumentsForCase(caseNumber, { documentTypeId });
  }
  
  onDisableNextStep(flag, isSkipNotifyMerchantCheckBox) {
    if (isSkipNotifyMerchantCheckBox && this.state.jsonHeadings[this.state.selectedIssuerIndex].viewCode !== 'RAI') {

      this.updateNextButtonStatus(flag);
      this.setState({ disabled: flag });

    } else {
      
      let letterTemplateLanguageId = this.state?.merchantMessage?.letterTemplateLanguageId;
      this.setState({ letterTemplateLanguageId });

      if (this.state.skipNotifyMerchant && this.state.jsonHeadings[this.state.selectedIssuerIndex].reviewScreenKey == 'merchantMessage') {
        this.updateNextButtonStatus(this.state.merchantMessage.returnToPDRFlag ? !this.state.pdrReasonPresent : false);
        this.setState({ disabled: this.state.merchantMessage.returnToPDRFlag ? !this.state.pdrReasonPresent : false })
      } else {
          this.updateNextButtonStatus(this.state.merchantMsgPresent && this.state.pdrReasonPresent ? flag : true);
          this.setState({ disabled: this.state.merchantMsgPresent && this.state.pdrReasonPresent ? flag : true });
      }

    }

  }

  clearFilters = () => {
    this.setState({
      currentValues: {},
    });
  }

  // only text area validations
  validateTextArea(note, isRequired) {
    if (!isRequired) {
      this.updateNextButtonStatus(false);
    }
    else if (note.trim() !== '') {
      this.updateNextButtonStatus(false);
    } else if (note.trim() == '') {
      this.updateNextButtonStatus(true);
    }
  }

  // agreement status and text area validation
  validateTextAndAgreementStatus(note, isFinancialLossOccured) {
    if (note.trim() !== '' && isFinancialLossOccured) {
      this.updateNextButtonStatus(false);
    } else if (note.trim() !== '' && !isFinancialLossOccured) {
      this.updateNextButtonStatus(true);
    }
  }
  // dropdown and text area validation
  validateDropDownAndTextArea(note, selectedOption, isTextRequired) {
    if (selectedOption !== null) {
      if (selectedOption !== undefined && (selectedOption.value == true || selectedOption.value == false)) {
        this.setState({
          comment: {
            commentText: note,
            externalComment: selectedOption.value,
          },
        });
        if (note.trim() !== '') {
          this.updateNextButtonStatus(false);
        } else if (selectedOption !== undefined && !isTextRequired) {
          if (selectedOption.length > 1 && selectedOption.findIndex(option => option == undefined || option == null) != -1) {
            this.updateNextButtonStatus(true);
          } else {
            this.updateNextButtonStatus(false);
          }
        }
      } else if (selectedOption !== undefined && note.trim() !== '') {
        if (selectedOption.length > 1 && selectedOption.findIndex(option => option == undefined || option == null) != -1) {
          this.updateNextButtonStatus(true);
        } else {
          this.updateNextButtonStatus(false);
        }
      } else if (selectedOption !== undefined && !isTextRequired) {
        if (selectedOption.length > 1 && selectedOption.findIndex(option => option == undefined || option == null) != -1) {
          this.updateNextButtonStatus(true);
        } else {
          this.updateNextButtonStatus(false);
        }
      }
      else {
        this.updateNextButtonStatus(true);
      }
    } 
  }
  //Validate textarea,dropdown,select search 
  validateComboSearchDropDown(note, selectedOption, searchValue) {
    if (selectedOption !== null && searchValue !== null) {
      if (selectedOption !== undefined && searchValue != undefined) {
        var transferCase = {
          disputeComments: note,
          transferReasonCode: selectedOption.length > 0 && selectedOption[0].value,
          assignedTo: searchValue.value,
          caseStageId : this.props.latestCaseStageId,
        };
        this.setState({
          transferCase
        });
        if (selectedOption !== undefined && note.trim() !== '' && Object.getOwnPropertyNames(searchValue).length !== 0) {
          this.updateNextButtonStatus(false);
        } else {
          this.updateNextButtonStatus(true);
        }
      } else {
        this.updateNextButtonStatus(true);
      }
    }
  }
  onEndEdit(selectedOption, note, caseNumber, length, checkBoxStatus, isFinancialLossOccured, searchValue, isTextRequired, representmentAmount, selectedCurrency, financialLossExp) {
    let enableNextForFilingReason = isFinancialLossOccured === true && note && note.length > 0 ? false :true;
    isTextRequired = selectedOption && selectedOption[0] && selectedOption[0].responseType === __QUESTIONNAIRE__ &&
      (selectedOption[0].text === __FILE_COMPLIANCE__ || selectedOption[0].text === __INITIATE_PRE_COMPLIANCE__) ? enableNextForFilingReason : isTextRequired;/**NOTE : Adding this logic for Reason for Filing to be made required Field*/
    if (selectedOption == null && selectedOption !== undefined && searchValue == undefined) {
      // only text area validations
      if (isFinancialLossOccured == undefined) {
        this.validateTextArea(note, isTextRequired);
      } else {
        // agreement status and text area validation
        this.validateTextAndAgreementStatus(note, isFinancialLossOccured);
      }
    } else {
      if (searchValue !== undefined) {
        this.validateComboSearchDropDown(note, selectedOption, searchValue)
      }
      else {
        // dropdown and text area validation
        this.validateDropDownAndTextArea(note, selectedOption, isTextRequired);
      }
    }
    this.setActionData(note, caseNumber, length, selectedOption, checkBoxStatus, isFinancialLossOccured, representmentAmount, selectedCurrency, financialLossExp);
     /**
     *NOTE : Added this code for Oct Compliance to make 'Financial Loss Explaination' field Mandatory for VISA
     Ref : US245210,US245212
     */
    if (this.props.caseStageDetail.cardBrandCode === 'VI' && this.props.actionViewCode === 'PCF') {
    if(isFinancialLossOccured === true && (financialLossExp === '--' || financialLossExp.length === 0)){
      isTextRequired = true;
      this.updateNextButtonStatus(true);
    }
  }
  }
  /**
   * Set data of textarea,checkbox and dropdown in the selected component
   * @param {*} note
   * @param {*} caseNumber
   * @param {*} length
   * @param {*} selectedOption
   * @param {*} checkBoxStatus
   * @param {*} isFinancialLossOccured
   */
  setActionData(note, caseNumber, length, selectedOption, checkBoxStatus, isFinancialLossOccured, representmentAmount, selectedCurrency, financialLossExp) {
    const selectedActionIssuerId = this.state.jsonHeadings[this.state.selectedIssuerIndex].id;
    const updateIndex = this.state.issuerActionData.findIndex((issuerActionData) => {
      return issuerActionData.selectedActionIssuerId === selectedActionIssuerId;
    });

    let showQuesCurrency = selectedOption && selectedOption.length > 0 && selectedOption[0] && (selectedOption[0].text.trim().toLowerCase() == 'partial' || selectedOption[0].text.trim().toLowerCase() == 'accept partial' || (this.props.caseStageDetail.cardBrandCode == "DI" && this.props.caseStageDetail.disputeStageName == "Chargeback" && this.state.glBankAmount && this.state.glBankAmount.length == 1));
    if (!showApiLedgerFlag) {
      updatedAcceptanceAmount = {
        amount: representmentAmount,
        currency: selectedCurrency,
      };
    } 
    this.setState({
      showQuesCurrency,
      setAcceptanceAmount : representmentAmount,
    })
    let isFinancialPage = (this.state.selectedIssuerIndex == 0 && this.state.jsonHeadings[this.state.selectedIssuerIndex].reviewScreenKey == 'financialAdjustment') ||
      (this.state.jsonHeadings[this.state.selectedIssuerIndex].reviewScreenKey == ActionConstants.__REPRESENTMENT_QUESTION_KEY__ &&
        (showQuesCurrency || (this.props.caseStageDetail.cardBrandCode == "DI" && this.props.caseStageDetail.disputeStageName == "Chargeback") || (this.props.caseStageDetail.cardBrandCode == 'VI' && (this.props.caseStageDetail.disputeStageName == 'Incoming Pre-Arbitration' || this.props.caseStageDetail.disputeStageName == 'Incoming Pre-Compliance')))) ? true : false;
    let currencyCode = [];
    currencyCode = selectedCurrency;
    if (updateIndex == -1) {

      if (isFinancialPage) {
        this.setState({
          issuerActionData: [...this.state.issuerActionData, {
            selectedActionIssuerId,
            isDocumentAttached: checkBoxStatus,
            note,
            caseNumber,
            length,
            selectedOption,
            isFinancialLossOccured,
            text: representmentAmount,
            showQuesCurrency: showQuesCurrency,
            currencyCode,
            financialLossExp
          }],

        });
      } else {
        this.setState({
          issuerActionData: [...this.state.issuerActionData, {
            selectedActionIssuerId,
            isDocumentAttached: checkBoxStatus,
            note,
            caseNumber,
            length,
            selectedOption,
            isFinancialLossOccured,
            financialLossExp
          }],

        });
      }
    } else {
      let issuerActionData = [...this.state.issuerActionData];
      issuerActionData[updateIndex].financialLossExp = financialLossExp;
      issuerActionData[updateIndex].note = note;
      issuerActionData[updateIndex].caseNumber = caseNumber;
      issuerActionData[updateIndex].isDocumentAttached = checkBoxStatus;
      issuerActionData[updateIndex].length = length;
      issuerActionData[updateIndex].selectedOption = selectedOption;
      issuerActionData[updateIndex].isFinancialLossOccured = isFinancialLossOccured;
      if (isFinancialPage) {
        issuerActionData[updateIndex].text = representmentAmount;
        issuerActionData[updateIndex].currencyCode = currencyCode;
        issuerActionData[updateIndex].showQuesCurrency = showQuesCurrency;
      } else {
        currencyCode[0] = this.props.merchantCurrencyCode;
        issuerActionData[updateIndex].text = representmentAmount;
        issuerActionData[updateIndex].currencyCode = currencyCode;
        issuerActionData[updateIndex].showQuesCurrency = undefined;
      }
      this.setState({ issuerActionData, representmentAmount });
      
    }
  }

  callPCFActionForProsaSCB(){
    submitTakeActionResponse(this.preparePostDataForProsaPCFSCB(this.state), this.props.caseNumber).then((res) => {
      if (res.status && (res.status.statusCode == 2000 || res.status.statusCode == 200)) {
        this.setsubmitResponseBanner();
        if (this.props.submitActionOption === 'Close Case') {
          this.props.setCaseStatus('Close');
        }
        this.closeActionForIssuerAction();
        this.setState({
          isVisible: false,
          issuerActionData: [],
          isLoading: false,
          isSubmitButtonClicked: false,
        }, () => {
          this.props.getSubmitActionStatus(false);
        });
      } if (res.status.statusCode == 2007 && res.data == 'Failed') {
        this.setState({
          bannerResponseMessage: 'Please Select another Date.',
          isRequestWarningBanner: true,
          isDataUploaded: false,
          isError: false,
          commentText: '',
          isVisible: true,
          isLoading: false,
          isSubmitButtonClicked: false,
        }, () => {
          this.props.getSubmitActionStatus(false);
        });
      }
    }).catch((res) => {
      if (this.props.submitActionOption === 'Close Case' && res.response && (res.response.status == 4000 || res.response.status == 400)) {
        this.setState({
          bannerResponseMessage: 'This Case is already closed :',
          isDataUploaded: false,
          isError: true,
          commentText: '',
          isVisible: true,
          isLoading: false,
          isSubmitButtonClicked: false,
        }, () => {
          this.props.getSubmitActionStatus(false);
        });
      } else {
        const selectedActionId = parseInt(this.props.selectedActionId);
        const selectedOptionvalue = this.props.submitActionOption;
        this.setState({
          bannerResponseMessage: this.props.selectedOptionvalue === 'Close Case' ? 'Close case operation failed for the case number :' : `Send ${selectedActionId == ActionConstants.__RESPOND_TO_ISSUER_ID__ ? 'Response to Issuer' : selectedOptionvalue} failed for the case number :`,
          isDataUploaded: false,
          isError: true,
          commentText: '',
          isLoading: false,
          isSubmitButtonClicked: false,
        }, () => {
          this.props.getSubmitActionStatus(false);
        });
      }
    });

  }


  setsubmitResponseBanner() {
    const selectedActionId = parseInt(this.props.selectedActionId);
    const selectedOptionvalue = this.props.submitActionOption;
    this.props.resetActionPane();
    this.props.resetCaseData(this.props.caseNumber);
    this.props.setNotification([{
      title: 'Success',
      titleStyle: "color: 'light-green'",
      description: selectedOptionvalue === 'Close Case' ? 'Close case operation successful for the case number :' : `${selectedActionId == ActionConstants.__RESPOND_TO_ISSUER_ID__ ? 'Response to Issuer' : selectedOptionvalue} has been submitted for case #`,
      descriptionStyle: "color: 'grey'",
      type: 'success',
      cancelButtonText: 'CLOSE',
      cancelOnly: true,
      primaryButtonActionValue: this.props.caseNumber,
      valueStyle: "color: 'black'",
      closeNotification: this.props.closeNotification,
    }]);
  }

  // Banner for success message after form submission
  setAddNoteBanner() {
    this.props.setNotification([{
      title: 'Success',
      titleStyle: "color: 'light-green'",
      description: this.state.bannerResponseMessage,
      descriptionStyle: "color: 'grey'",
      type: 'success',
      cancelButtonText: 'DISMISS',
      primaryButtonText: 'OKAY, GREAT!',
      isSecondaryButton: 'DISMISS',
      isSecondaryButtonActive: true,
      primaryButtonActionValue: this.props.caseNumber,
      valueStyle: "color: 'black'",
      closeNotification: this.props.closeNotification,
      primaryButtonAction: this.props.closeNotification,
      secondaryButtonAction: this.props.closeNotification,

    }]);
  }
  // update pageListArray data on the basis of document type whether it is issuer or merchant
  updatePageListArray(pageListArray, documentType, fileIndex) {
    const pageData = 
      this.props.caseDocuments[documentType].pageListArray ? 
      [...this.props.caseDocuments[documentType].pageListArray] 
      : [...this.props.caseDocuments.pageListArray];
    pageData[fileIndex] = pageListArray;
    let data = [];
    pageListArray.map((image) => {
      data = data.concat([image.pageContent]);
    });
    const updatedSelectedFile = this.props.caseDocuments[documentType].selectedPages[fileIndex];
    const tempSelectedPages = this.props.caseDocuments[documentType].selectedPages;
    if (updatedSelectedFile !== undefined) {
      for (let i = 0; i < pageData[fileIndex].length; i++) {
        for (let j = 0; j < updatedSelectedFile.length; j++) {
          if (updatedSelectedFile[j].pageContent !== pageData[fileIndex][i].pageContent && updatedSelectedFile[j].pageId == pageData[fileIndex][i].pageId) {
            updatedSelectedFile[j].pageContent = pageData[fileIndex][i].pageContent;
          }
        }
      }
      tempSelectedPages[fileIndex] = updatedSelectedFile;
    }
    const updatedToolKitData =
      this.props.caseDocuments[documentType].imageToolKitData ? 
      [...this.props.caseDocuments[documentType].imageToolKitData] 
      : [...this.props.caseDocuments.imageToolKitData];
    updatedToolKitData[fileIndex] = data;
    this.props.updateEditedPages(documentType, tempSelectedPages, pageData, updatedToolKitData);
  }

  /**
   * This method will update selected documents as per documentType in redux state
   * @param {*} documentType 
   * @param {*} orderOfSelectedPages 
   */
  updateSelectedCaseDocuments(documentType, orderOfSelectedPages, imageOrderSeq, selectedPages, selectedFileIndex, pageCount, selectAllFlag) {
    this.props.updateSelectedCasePages(documentType, orderOfSelectedPages, imageOrderSeq, selectedPages, selectedFileIndex, pageCount, selectAllFlag);
    let selectedPagesCount = { ...this.props.caseDocuments[documentType].pageCount };
    selectedPagesCount[selectedFileIndex] = pageCount;
    let selectedPageCount = 0;
    for (const key in selectedPagesCount) {
      if (selectedPageCount > 0) {
        break;
      }
      selectedPageCount += selectedPagesCount[key];
    }
    selectedPageCount > 0 ? this.onDisableNextStep(false) : this.onDisableNextStep(true);
  }

  // Set drop down list values for select input format
  setSelectionList(selectionList, selectedIssuerId) {
    switch (selectedIssuerId) {
      case 2:
      case 14:
      case 24:
      case 40:
        const finalSelectionList = [];
        for (let i = 0; i < selectionList.length; i++) {
          const selectedObj = {};
          selectedObj.text = selectionList[i].actionCodeDesc;
          selectedObj.responseToStageId = selectionList[i].responseToStageId;
          selectedObj.value = selectionList[i].stageConfigId;
          selectedObj.responseType = selectionList[i].responseType;
          selectedObj.stageId = selectionList[i].stageId;
          finalSelectionList.push(selectedObj);
        }
        var actionDescriptionList = [...this.state.actionDescriptionList];
        let actionDescriptionIndex = actionDescriptionList.findIndex((item) => item.selectedActionIssuerId == selectedIssuerId);
        if (actionDescriptionIndex != -1) {
          actionDescriptionList[actionDescriptionIndex].finalSelectionList = finalSelectionList;
        } else {
          actionDescriptionList.push({
            selectedActionIssuerId: selectedIssuerId,
            finalSelectionList,
          });
        }
        this.setState({
          actionDescriptionList: actionDescriptionList,
        })

        break;
        case ActionConstants.__REQUEST_ISSUER_DOCUMENT__:
          const ridSelectionList = [];
          for (let i = 0; i < selectionList.length; i++) {
            const selectedObj = {};
            selectedObj.text = selectionList[i].responseReasonDescription;
            selectedObj.value = selectionList[i].responseReasonCode;
            ridSelectionList.push(selectedObj);
          }
          var actionDescriptionList = this.state.actionDescriptionList;
          actionDescriptionList.push({
            selectedActionIssuerId: ActionConstants.__REQUEST_ISSUER_DOCUMENT__,
            finalSelectionList: ridSelectionList,
          });
  
          this.setState({
            actionDescriptionList: actionDescriptionList,
          })
          
          break;
      case ActionConstants.__TRANSFER_CASE_TRANSFERTO_ID__:
        const tempSelectionList = [];
        for (let i = 0; i < selectionList.length; i++) {
          const selectedObj = {};
          selectedObj.text = selectionList[i].transferReasonDescription;
          selectedObj.value = selectionList[i].transferReasonCode;
          tempSelectionList.push(selectedObj);
        }
        var actionDescriptionList = this.state.actionDescriptionList;
        actionDescriptionList.push({
          selectedActionIssuerId: ActionConstants.__TRANSFER_CASE_TRANSFERTO_ID__,
          finalSelectionList: tempSelectionList,
        });
        this.setState({
          actionDescriptionList: actionDescriptionList,
        })
        break;
      case ActionConstants.__TRANSFER_CASE_TRANSFERTO_ID__:

    }
  }



  setIssuerPageIndexes(selectedIssuerIndex, selectedActionIssuerId) {
    this.setState({
      selectedIssuerIndex,
      selectedActionIssuerId,
      textId: this.state.textId + 1,
    });
  }

  // Go to previous page
  previousIssuerPage() {
    document.getElementById('1_btn_prev').blur();
    const prevIndex = this.state.selectedIssuerIndex - 1;
    this.onPageChange(prevIndex);
  }

  checkDuplicateFinancials = () => {
    this.setState({
      isFinancialsDataLoading: true
    })
    let financialDataList = this.getAdjustFinancialDataForSubmit().ledgerInputList.filter(item => item.amount != "NaN");
    let merchantAdjustType = financialDataList.map(item => { if (item.ledgerAccountNumber == 1320 || item.ledgerAccountNumber == 24105) { return item.ledgerAdjustment } }).filter(item => item != undefined);

    if (merchantAdjustType.length !== 0) {
      getPrevFinancialsData(financialDataList, this.props.caseStageDetail.disputeStageId, this.props.caseNumber).then(apiResponse => {
        if (apiResponse.data == undefined || apiResponse.data.warningMsg == "NO_WARNING") {
          this.setState({
            isFinancialsDataLoading: false
          }, () => {
            this.gotoNextStep();
          })
        } else {
          this.setState({
            isFinancialAdjustmentWarning: true,
            customWarningMessage: apiResponse.data.warningMsg,
            warningType : apiResponse.data.warnType,
            caseAdjustment: apiResponse.data.caseAdjustment,
            isFinancialsDataLoading: false,
          }, () => {
            document.getElementById("ActionPane").scrollIntoView({behavior:"smooth", block: "start", inline:"start"});
            this.onDisableNextStep(false);
          })
        }
      }).catch(error => {
        console.log("Error while validating Financials", error)
        this.setState({
          isFinancialsDataLoading: false,
          customWarningMessage: "Error while validating Financials Error",
        });
        this.onDisableNextStep(false);
      })
    } else {
      this.setState({
        isFinancialsDataLoading: false
      }, () => {
        this.gotoNextStep();
      })
    }
  }

  validateAttachedDocSize = () => {
    document.getElementById("ActionPane").scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
    this.setState({
      isLoading: true,
    });
    let issuerDocData = getIssuerDocData(
      this.props.caseDocuments.issuerImageData.orderOfSelectedPages
    );
    let payload = {
      documents: issuerDocData.documentsForIssuer,
      isDocumentsProvided: issuerDocData.issuerDocumentsProvided,
      actionCode: this.state.actionViewCode,
      caseStageId: this.state.caseStageId,
      userId: this.state.userId,
      acquirerCode: this.props.acquirerCode,
      documentType: issuerDocData.docType,
      documentName: issuerDocData.documentName
    };
    validateIssuerSentDocs(payload, this.props.caseNumber)
      .then((apiResponse) => {
        if (apiResponse.data != null && apiResponse.data == true) {
          this.setState(
            {
              isLoading: false,
            },
            () => {
              this.gotoNextStep();
            }
          );
        } else {
          this.setState(
            {
              bannerResponseMessage:
                "File(s) exceed maximum file size. Due to limits set by card brand, the total file size of all documents cannot exceed 1 MB. Please adjust your file(s) to meet the requirements.",
              isIssuerDocError: true,
              isLoading: false,
            },
            () => {
              document.getElementById("ActionPane").scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "start",
              });
            }
          );
        }
      })
      .catch((error) => {
        console.log("Error while validating issuer doc size", error);
        this.setState({
          isLoading: false,
          customWarningMessage: "Error while validating issuer doc size Error",
        });
      });
  };
  
  validateNoConversionDoc = () => {
    document.getElementById("ActionPane").scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
    this.setState({
      isLoading: true,
    });

    let issuerDocData = getIssuerDocData(
      this.props.caseDocuments.issuerImageData.orderOfSelectedPages
    );

    const multipleNoConversion = issuerDocData.documentTypes.filter(doc => doc === 'Docs to the Issuer-no conversion').length > 1;
    const noConversionDocWithOthers = issuerDocData.documentTypes.includes('Docs to the Issuer-no conversion') && issuerDocData.documentTypes.filter(doc => doc !== 'Docs to the Issuer-no conversion').length > 0;
    // Validation logic
    if (multipleNoConversion) {
      this.setState(
        {
          bannerResponseMessage: "File(s) selected cannot be merged. Select only one document labeled Docs to Issuer-No conversion before proceeding.",
          isIssuerDocError: true,
          isLoading: false,
        },
        () => {
          document.getElementById("ActionPane").scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "start",
          });
        }
      );
      return false; // Return false if validation fails
    }else if (noConversionDocWithOthers) {
      this.setState(
        {
          bannerResponseMessage: "File(s) selected have different file formats. Select only documents labeled Docs to Issuer-No conversion or remove those documents from your response.",
          isIssuerDocError: true,
          isLoading: false,
        },
        () => {
          document.getElementById("ActionPane").scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "start",
          });
        }
      );
      return false; // Return false if validation fails
    }else{
    return true; // Return true if all validation checks pass
    }
  };

  // Go to next page
  gotoNextStep() {
    this.setState({ isFinancialAdjustmentWarning: false, isAnnex19Present: false });
    document?.getElementById('1_btn_next')?.blur();
    if (this.state.maxActionIssuerLength > this.state.selectedIssuerIndex) {
      this.onPageChange(this.state.selectedIssuerIndex + 1);
    }
  }

  closeBanner() {
    this.setState({
      isError: false,
      isWarning: false,
      isRequestWarningBanner: false,
      isDataUploaded: false,
      isIssuerDocError: false
    });
  }
  showWarningBanner() {
    if (this.state.isWarning) {
      return (
        <div>
          <ImagePortal>
          <ResponseBanner
            titleStyle={{ color: 'light-green' }}
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title="Are you Sure you Want to Cancel?"
            description={ActionConstants.__EMPTY_STRING__}
            type="warning"
            onClose={this.closeBanner}
            cancelButtonText="DO NOT CANCEL"
            secondaryButtonAction={this.closeBanner}
            primaryButtonText="YES, PLEASE CANCEL"
            primaryButtonAction={this.closeActionPane}
          />
           </ImagePortal>
        </div>
      );
    }
  }

  showErrorBanner() {
    if (this.state.isError) {
      return (
        <div>
           <ImagePortal>
          <ResponseBanner
            titleStyle={{ color: 'light-green' }}
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title="Error Occured"
            description={this.state.bannerResponseMessage}
            type="danger"
            onClose={this.closeBanner}
            cancelButtonText="DISMISS"
            primaryButtonActionValue={this.state.selectedCaseNumber}
            primaryButtonText="OKAY, DO SOMETHING TO FIX IT"
            primaryButtonAction={this.closeBanner}
          />
           </ImagePortal>
        </div>
      );
    }
  }

  showIssuerDocErrorBanner() {
    if (this.state.isIssuerDocError) {
      return (
        <div>
           <ImagePortal>
          <ResponseBanner
            cancelOnly={true}
            titleStyle={{ color: 'light-green' }}
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title="Error Occured"
            description={this.state.bannerResponseMessage}
            type="danger"
            onClose={this.closeBanner}
            cancelButtonText="DISMISS"
          />
           </ImagePortal>
        </div>
      );
    }
  }
  
  compare(a, b) {
    // Use toUpperCase() to ignore character casing
    const genreA = a.seqNo;
    const genreB = b.seqNo;

    let comparison = 0;
    if (genreA > genreB) {
      comparison = 1;
    } else if (genreA < genreB) {
      comparison = -1;
    }
    return comparison;
  }

  acceptFinancialLoss(isFinancialLossOccured) {
    this.setState({
      [this.state.selectedActionIssuerId]: { isFinancialLossOccured },
    });
  }

  attachDocumentPage(selectedId, operation, attachIndex, issuerActionData) {
  // Generic helper: compute jsonHeadings for an 'all' (multi-page) attach toggle.
    // Looks at all 'all'-typed checkboxes on the source page and includes attachArray
    // pages whose `ownerCheckboxIndex` (if set) corresponds to a still-checked box.
    // Pages without `ownerCheckboxIndex` are shared and always included while at
    // least one 'all' checkbox is on. Returns defaultActionData if none are on.
    const computeAllAttachPages = (sourcePage, toggledIndex, isPush) => {
      const prevCheckBoxItem = this.state.checkBoxStatus.find(
        (cb) => cb.selectedActionIssuerId == this.state.selectedActionIssuerId,
      );
      const prevStatus = prevCheckBoxItem ? prevCheckBoxItem.status : [];
      const willBeChecked = (idx) =>
        idx === toggledIndex ? isPush : !!prevStatus[idx];
      const activeIndices = (sourcePage.attachType || [])
        .map((t, i) => (t === 'all' && willBeChecked(i) ? i : -1))
        .filter((i) => i !== -1);
      if (activeIndices.length === 0) {
        return { pages: this.state.defaultActionData, activeIndices };
      }
      const pages = this.state.attachArray.filter(
        (page) =>
          page.ownerCheckboxIndex === undefined ||
          activeIndices.includes(page.ownerCheckboxIndex),
      );
      return { pages, activeIndices };
    };

    switch (operation) {
      case ActionConstants.__PUSH__:
        let arr = [...this.state.jsonHeadings];
        for (const index in this.state.attachArray) {
          const attachValue = Array.isArray(this.state.jsonHeadings[selectedId].attachType) ? this.state.jsonHeadings[selectedId].attachType[attachIndex] : this.state.jsonHeadings[selectedId].secondaryAttachType ? this.state.jsonHeadings[selectedId].secondaryAttachType[attachIndex] : undefined;
          if (attachValue) {
            if (attachValue === this.state.attachArray[index].attachType && !(this.state.jsonHeadings.some(ele => (!Array.isArray(ele.attachType) && (ele.attachType === attachValue))))) {
              arr.splice(selectedId + 1, 0, this.state.attachArray[index]);
              break;
            } else if (attachValue == 'all') {
              const sourcePage = this.state.jsonHeadings[selectedId];
              const { pages } = computeAllAttachPages(sourcePage, attachIndex, true);
              arr = pages;
              this.setState({
                primaryButtonText: arr[0].primaryButtonText,
                submitButtonText: arr[0].submitButtonText,
                cancelButtonText: arr[0].cancelButtonText,
                secondaryButtonText: arr[0].secondaryButtonText,
              });
              break;
            }
          }
        }
        arr.sort(this.compare);
        let issuerActionDataCopy = [...issuerActionData];
        this.setState({
          jsonHeadings: arr,
          maxActionIssuerLength: arr.length,
          issuerActionData: issuerActionDataCopy
        });
        this.updateCheckBoxStatus(true, attachIndex);
        break;
      case ActionConstants.__POP__:
        let popArray = Object.assign([], this.state.jsonHeadings);
        const popAttachValue = Array.isArray(this.state.jsonHeadings[selectedId].attachType) ? this.state.jsonHeadings[selectedId].attachType[attachIndex] : this.state.jsonHeadings[selectedId].secondaryAttachType ? this.state.jsonHeadings[selectedId].secondaryAttachType[attachIndex] : undefined;
        this.resetAttachPageData(popAttachValue);
        const updateIndex = this.state.jsonHeadings.findIndex((jsonObject) => {
          return jsonObject.attachType === popAttachValue;
        });
        let secondaryAttachType = updateIndex !== -1 && this.state.jsonHeadings[updateIndex] ? this.state.jsonHeadings[updateIndex].secondaryAttachType : undefined;
        const updateSecondaryIndex = secondaryAttachType ? this.state.jsonHeadings.findIndex((jsonObject) => {
          return secondaryAttachType.indexOf(jsonObject.attachType) > -1;
        }) : -1;
        for (const index in this.state.attachArray) {
          if (popAttachValue === this.state.attachArray[index].attachType && updateSecondaryIndex != -1 && secondaryAttachType && secondaryAttachType == this.state.attachArray[index].secondaryAttachType) {
            popArray.splice(updateIndex, 1);
            popArray.splice(updateSecondaryIndex - 1, 1);
            const newUpdateIndex = this.state.checkBoxStatus.findIndex((checkBox) => {
              return checkBox.selectedActionIssuerId == this.state.jsonHeadings[updateSecondaryIndex].seqNo;
            });
            if (this.state.checkBoxStatus !== undefined && this.state.checkBoxStatus.length > 0) {
              var statusArray = this.state.checkBoxStatus[newUpdateIndex].status;
              statusArray[0] = false;
              const checkBoxStatus = this.state.checkBoxStatus;
              checkBoxStatus[newUpdateIndex].status = statusArray;
              this.setState({ checkBoxStatus });
            }
            break;
          }
          else if (popAttachValue === this.state.attachArray[index].attachType) {
            popArray.splice(updateIndex, 1);
            break;
          } else if (popAttachValue == 'all') {
            // Generic: keep pages that are still owned by other checked 'all' boxes.
            const sourcePage = this.state.jsonHeadings[selectedId];
            const { pages } = computeAllAttachPages(sourcePage, attachIndex, false);
            popArray = pages;
            this.setState({
              primaryButtonText: popArray[0].primaryButtonText,
              submitButtonText: popArray[0].submitButtonText,
              cancelButtonText: popArray[0].cancelButtonText,
              secondaryButtonText: popArray[0].secondaryButtonText,
            });
            break;
          }
        }
        let issuerActionDataCopy2 = [...issuerActionData];
        this.setState({
          jsonHeadings: popArray,
          maxActionIssuerLength: popArray.length,
          issuerActionData: issuerActionDataCopy2
        });
        this.updateCheckBoxStatus(false, attachIndex);
        break;
    }
  }

  /**
   * This method is responsible for resetting the attach array data.
   * @param {ex: merchant or issuer} attachValue
   */
  resetAttachPageData(attachValue) {
    let selectedActionIssuerId = -1;
    if (attachValue == ActionConstants.__MERCHANT_DOCS__) {
      const updatedStatus = this.state.buttonStatus.findIndex((buttonStatus) => {
        return (buttonStatus.selectedActionIssuerId == ActionConstants.__NOTIFY_AND_REQUEST_MERCH_DOCS_ID__ || buttonStatus.selectedActionIssuerId == ActionConstants.__REQUEST_ADDITIONAL_INFO_MERCH_DOCS_ID__ || buttonStatus.selectedActionIssuerId == ActionConstants.__RESPOND_TO_ISSUER_MERCH_DOCS_ID__ || buttonStatus.selectedActionIssuerId == ActionConstants.__UNABLE_TO_DEFEND_PURSUE_MERCH_DOCS_ID__ || buttonStatus.selectedActionIssuerId == ActionConstants.__WRITEOFF_GOODWILL_MERCH_DOCS_ID__);
      });
      if (updatedStatus !== -1) {
        const selectedButtonStatus = this.state.buttonStatus;
        selectedButtonStatus[updatedStatus].status = true;
        this.setState({
          buttonStatus: selectedButtonStatus,
        });
      }
      this.props.resetSelectedDocuments(ActionConstants.__MERCHANT_IMAGE_DATA__);
    } else if (attachValue == ActionConstants.__ISSUER_DOCS__) {
      const updatedIssuerStatus = this.state.buttonStatus.findIndex((buttonStatus) => {
        return (buttonStatus.selectedActionIssuerId == ActionConstants.__RESPOND_TO_ISSUER_ISSUER_DOCS_ID__);
      });
      if (updatedIssuerStatus !== -1) {
        const selectedButtonStatus = this.state.buttonStatus;
        selectedButtonStatus[updatedIssuerStatus].status = true;
        this.setState({
          buttonStatus: selectedButtonStatus,
        });
      }
      this.props.resetSelectedDocuments(ActionConstants.__ISSUER_IMAGE_DATA__);
    } else if (attachValue == ActionConstants.__ADJUST_FINANCIAL__) {
      this.props.resetNestedFieldSelectorData();
    } else if (attachValue == ActionConstants.__MERCHANT_ADVICE_KEY__) {
      this.resetMerchantMessages();
    }

    else if (attachValue == ActionConstants.__ACCEPT_LIABILITY_KEY__) {
      const updateIndex = this.state.issuerActionData.findIndex((issuerActionData) => {
        return (issuerActionData.selectedActionIssuerId == ActionConstants.__UNABLE_TO_DEFEND_PURSUE_ACCEPT_LIABILITY_ID__ || issuerActionData.selectedActionIssuerId == ActionConstants.__WRITEOFF_GOODWILL_ACCEPT_LIABILITY_ID__);
      });
      if (updateIndex !== -1) {
        let issuerActionData = [...this.state.issuerActionData];
        selectedActionIssuerId = issuerActionData[updateIndex].selectedActionIssuerId;
        issuerActionData[updateIndex].note = '';
        issuerActionData[updateIndex].caseNumber = this.props.caseNumber;
        issuerActionData[updateIndex].isDocumentAttached = false;
        issuerActionData[updateIndex].length = length;
        issuerActionData[updateIndex].selectedOption = null;
        issuerActionData[updateIndex].isFinancialLossOccured = false;
        this.setState({ issuerActionData, [selectedActionIssuerId]: { isFinancialLossOccured: false } });
      }
    } else if (attachValue == ActionConstants._CLOSE_ACTION_DOCS) {
      this.props.resetNestedFieldSelectorData();
      this.resetMerchantMessages();
    }
    if (selectedActionIssuerId !== -1) {
      const updateIndex = this.state.buttonStatus.findIndex((buttonStatus) => {
        return (buttonStatus.selectedActionIssuerId == selectedActionIssuerId);
      });
      const selectedButtonStatus = this.state.buttonStatus;
      selectedButtonStatus[updateIndex].status = true;

      this.setState({
        buttonStatus: selectedButtonStatus,
      });
    }
  }

  resetMerchantMessages(keepSomeValues, messageTypeState) {
    let messageType = (keepSomeValues && messageTypeState) ? {value: 'predefined', text: 'Predefined'} : {value: 'custom', text: 'Custom'};
    let letterTemplateLanguageId = keepSomeValues ? this.state.merchantMessage?.letterTemplateLanguageId : 0;
    let merchantDocumentsProvided = keepSomeValues ? this.state.merchantDocumentsProvided : false;
    let returnToPDRFlag = keepSomeValues ? this.state.merchantMessage.returnToPDRFlag:false;
    let reasonForAdditionalReview = keepSomeValues ? this.state.merchantMessage?.reasonForAdditionalReview:'';

    let englishMessage = keepSomeValues ? this.state.englishMessage : "";
    let otherMessage = keepSomeValues ? this.state.otherMessage : "";

    let merchantMessageTemp = [];
    let defaultMessage = "No advice generated";

    if (keepSomeValues && englishMessage?.length > 0) {
      merchantMessageTemp.push(
        {
          ...this.state.merchantMessageTemp.filter(item => item?.title != "Letter Template")[0],
          desc: englishMessage
        }
      )
    }
    if (keepSomeValues && otherMessage?.length > 0) {
      merchantMessageTemp.push(
        {
          ...this.state.merchantMessageTemp.filter(item => item?.title != "Letter Template")[1],
          desc: otherMessage
        }
      )
    }

    if(keepSomeValues && !messageTypeState) {
      merchantMessageTemp.push(
        {
          title: "Letter Template",
          desc: defaultMessage
        }
      )
    }

    merchantMessageTemp = merchantMessageTemp.filter(item => item?.title != null && item?.desc != null)

    this.setState({
      merchantMessage: {
        documentsForMerchant: [
          {
            base64EncodedImage: 'string',
            imageFormat: 'string',
          },
        ],
        letterMessage: englishMessage,
        merchPrefLangLetterMessage: otherMessage,
        letterTemplateLanguageId,
        merchantDocumentsProvided,
        returnToPDRFlag,
        reasonForAdditionalReview,
        notifyMerchant: this.state.skipNotifyMerchant ? false : true,
      },
      merchantMessageTemp,
      messageType,
      englishMessage,
      otherMessage,
      predefMessageData: {
        englishLanguage: '',
        preferredLanguage: '',
      },
      letterTemplate: {
        value: 'choose-one',
        text: 'Choose One',
      },
    });
  }

  updateNextButtonStatus(status) {
    const updateIndex = this.state.buttonStatus.findIndex((singleButton) => {
      return singleButton.selectedActionIssuerId == this.state.selectedActionIssuerId;
    });
    if (updateIndex == -1) {
      this.setState({
        buttonStatus: [...this.state.buttonStatus, {
          selectedActionIssuerId: this.state.selectedActionIssuerId,
          status,
        }],
      });
    } else if (this.state.buttonStatus !== undefined && this.state.buttonStatus.length > 0) {
      const buttonStatus = this.state.buttonStatus;
      buttonStatus[updateIndex].status = status;
      this.setState({ buttonStatus });
    }
  }

  skipNotifyMerchant = (status, attachIndex) => {
    let merchantMessage = {
      ...this.state?.merchantMessage,
      letterTemplateLanguageId: status ? VITE_DEFAULT_LETTER_TEMPLATE_LANGUAGE_ID : this.state?.letterTemplateLanguageId,
      notifyMerchant : !status
    };
    
    this.setState({
      skipNotifyMerchant: status,
      merchantMessage,
      merchantMsgPresent : false,
    },
      () => {
        this.updateCheckBoxStatus(status, attachIndex);
        if (status) {
          this.setState({ 
           predefMessages: []
          })
            this.onDisableNextStep(!status, true);
            this.resetMerchantMessages(true);
        } else {
          this.onDisableNextStep(true, false);
          this.resetMerchantMessages(true, true);
          this.setState({
            predefMessages: this.state.duplicatePredefMessages
          })
        }
      },)
}

  updateCheckBoxStatus(status, attachIndex) {
    if (this.state.selectedActionIssuerId !== undefined) {
      attachIndex = attachIndex == undefined ? 0 : attachIndex;
      const updateIndex = this.state.checkBoxStatus.findIndex((checkBox) => {
        return checkBox.selectedActionIssuerId == this.state.selectedActionIssuerId;
      });
      if (updateIndex == -1) {
        const statusArray = [];
        statusArray[attachIndex] = status;
        this.setState({
          checkBoxStatus: [...this.state.checkBoxStatus, {
            selectedActionIssuerId: this.state.selectedActionIssuerId,
            status: statusArray,
          }],
        });
      } else if (this.state.checkBoxStatus !== undefined && this.state.checkBoxStatus.length > 0) {
        const statusArray = this.state.checkBoxStatus[updateIndex].status;
        if(this.state.selectedActionIssuerId == "12" && (attachIndex == "3" || attachIndex == "4")) {
              if(attachIndex == "3"){
                statusArray[attachIndex] = status;
                statusArray[4] = statusArray[4]? !status : false;
              } else {
                statusArray[attachIndex] = status;
                statusArray[3] = statusArray[3]? !status : false;
              }
        } else {
              statusArray[attachIndex] = status;
        }

        const checkBoxStatus = this.state.checkBoxStatus;
        checkBoxStatus[updateIndex].status = statusArray;
        this.setState({ checkBoxStatus });
      }
    }
  }
  getDeadlineDate(date) {
    const messagesTemp = this.state.merchantMessageTemp.filter((item) => {
      return item.title !== 'Deadline Date';
    });
    const deadLineDate = {
      title: 'Deadline Date',
      desc: date,
    };
    if (date !== null && date !== undefined && date !== '') {
      const updatedMerchantMessage = { ...this.state.merchantMessage };
      updatedMerchantMessage.deadLineDate = date;
      this.setState({
        merchantMessage: updatedMerchantMessage,
      });
      messagesTemp.push(deadLineDate);
    }
    this.setState({
      merchantMessageTemp: messagesTemp,
    });
  }
  fetchEnglishMessageData(messageData, langIndCode) {
    const messagesTemp = this.state.merchantMessageTemp.filter((item) => {
      return item.title !== 'Message in English Language' && item.title !== 'Message';
    });
    const englishMessage = langIndCode === 'EN' ? {
      title: 'Message',
      desc: messageData,
    } : {
        title: 'Message in English Language',
        desc: messageData,
      };
    if (this.state.letterTemplate.text !== 'Choose One') {
      this.setState({
        merchantMsgPresent : (messageData.trim() !== '' || this.state.otherMessage.trim() !== '') 
      }, () =>  {
        this.onDisableNextStep((messageData.trim() !== '' || this.state.otherMessage.trim() !== '') ? false : true);
      })
    }
    if (messageData !== null && messageData !== undefined && messageData !== '') {
      messagesTemp.push(englishMessage);
    }
    this.setState({
      merchantMessageTemp: messagesTemp,
      languageIndCode: langIndCode,
      englishMessage: messageData,
    });

    const updatedMerchantMessage = { ...this.state.merchantMessage };
    updatedMerchantMessage.letterMessage = messageData.trim();
    this.setState({
      merchantMessage: updatedMerchantMessage,
    });
  }

  fetchOtherMessageData(messageData, langIndCode, langText) {
    const messagesTemp = this.state.merchantMessageTemp.filter((item) => {
      return item.title !== `Message in Merchant's Preferred Language (${langText})`;
    });

    const otherMessage = {
      title: `Message in Merchant's Preferred Language (${langText})`,
      desc: messageData,
    };
    if (this.state.letterTemplate.text !== 'Choose One') {
      this.setState({
        merchantMsgPresent : (messageData.trim() !== '' || this.state.englishMessage.trim() !== '') 
      }, () =>  {
        this.onDisableNextStep((messageData.trim() !== '' || this.state.englishMessage.trim() !== '') ? false : true);
      })
    }
    if (messageData !== null && messageData !== undefined && messageData !== '') {
      messagesTemp.push(otherMessage);
    }
    this.setState({
      merchantMessageTemp: messagesTemp,
      languageIndCode: langIndCode,
      otherMessage: messageData,
    });

    const updatedMerchantMessage = { ...this.state.merchantMessage };
    updatedMerchantMessage.merchPrefLangLetterMessage = messageData;
    this.setState({
      merchantMessage: updatedMerchantMessage,
    });
  }

  fetchMessageType(messageType) {
    this.setState({
      messageType,
    });
  }

  fetchPredefMessageData(messageData, langIndCode, langText) {
    if (langIndCode === 'EN') {
      const messagesTemp = this.state.merchantMessageTemp.filter((item) => {
        return item.title !== 'Message' && item.title !== 'Message in English Language';
      });

      const englishMessage = {
        title: 'Message',
        desc: messageData.englishLanguage,
      };
      messagesTemp.push(englishMessage);
      if (this.state.letterTemplate.text !== 'Choose One') {
        this.setState({
          merchantMsgPresent : (messageData.englishLanguage.trim() !== '' || this.state.predefMessageData.englishLanguage.trim() !== '') 
        }, () =>  {
          this.onDisableNextStep((messageData.englishLanguage.trim() !== '' || this.state.predefMessageData.englishLanguage.trim() !== '') ? false : true);
        })
      } else {
        this.setState({
          merchantMsgPresent : false 
        }, () =>  {
          this.onDisableNextStep(true);
        })
      }
      this.setState({
        merchantMessageTemp: messagesTemp,
        languageIndCode: langIndCode,
        langText,
      });
    } else {
      const messagesTemp = this.state.merchantMessageTemp.filter((item) => {
        return item.title !== `Message in Merchant's Preferred Language (${langText})` && item.title !== 'Message' && item.title !== 'Message in English Language';
      });

      const englishMessage = {
        title: 'Message in English Language',
        desc: messageData.englishLanguage.trim(),
      };
      const otherMessage = {
        title: `Message in Merchant's Preferred Language (${langText})`,
        desc: messageData.preferredLanguage !== null ? messageData.preferredLanguage.trim() : '',
      };
      messagesTemp.push(englishMessage);
      messagesTemp.push(otherMessage);
      if (this.state.letterTemplate.text !== 'Choose One') {
          this.setState({
            merchantMsgPresent : (messageData.englishLanguage.trim() !== '' || this.state.predefMessageData.englishLanguage.trim() !== '') 
          }, () =>  {
            this.onDisableNextStep((messageData.englishLanguage.trim() !== '' || this.state.predefMessageData.englishLanguage.trim() !== '') ? false : true);
          })
        } else {
          this.setState({
            merchantMsgPresent : false 
          }, () =>  {
            this.onDisableNextStep(true);
          })
      }
      this.setState({
        merchantMessageTemp: messagesTemp,
        languageIndCode: langIndCode,
      });
    }

    let documentsForMerchant = [];
    const updateIndex = this.state.issuerActionData.findIndex((actionData) => {
      return actionData.selectedActionIssuerId == ActionConstants.__RESPOND_TO_ISSUER_MERCH_MSG_ID__ || actionData.selectedActionIssuerId == ActionConstants.__UNABLE_TO_DEFEND_PURSUE_MERCH_MSG_ID__ || actionData.selectedActionIssuerId == ActionConstants.__REQUEST_ADDITIONAL_INFO_MERCH_MSG_ID__ || actionData.selectedActionIssuerId == ActionConstants.__WRITEOFF_GOODWILL_MERCH_MSG_ID__;
    });

    const selectedPages = this.state.merchantImageData == undefined ? [] : this.state.merchantImageData.selectedPages;
    if (selectedPages !== undefined) {
      const values = Object.values(selectedPages);
      for (const imageArray of values) {
        imageArray.map((image) => {
          const docObj = {};
          docObj.base64EncodedImage = image.pageContent;
          docObj.imageFormat = 'png';
          documentsForMerchant = documentsForMerchant.concat(docObj);
        });
      }
    }

    const updatedMerchantMessage = { ...this.state.merchantMessage };
    const letterMessageCopy = messageData.englishLanguage.trim();
    const merchantDocumentsProvided = this.state.checkBoxStatus[updateIndex] == undefined || documentsForMerchant.length == 0 ? false : this.state.checkBoxStatus[updateIndex].status;
    updatedMerchantMessage.letterMessage = letterMessageCopy;
    updatedMerchantMessage.merchPrefLangLetterMessage = messageData.preferredLanguage !== undefined && messageData.preferredLanguage !== null ? messageData.preferredLanguage.trim() : '';
    updatedMerchantMessage.documentsForMerchant = documentsForMerchant;
    updatedMerchantMessage.merchantDocumentsProvided = merchantDocumentsProvided;
    updatedMerchantMessage.verbiageLanguageId = messageData.verbiageLanguageId;
    this.setState({
      merchantMessage: updatedMerchantMessage,
      predefMessageData: messageData,
    });
  }

  fetchMerchantDocumentFlag(isProvided) {
    const updatedMerchantMessage = { ...this.state.merchantMessage };
    updatedMerchantMessage.merchantDocumentsProvided = isProvided;
    this.setState({
      merchantMessage: updatedMerchantMessage,
    });
  }

  fetchLangId(letterTemplate, languageId) {
    const templatesTemp = this.state.merchantMessageTemp.filter((item) => {
      return item.title !== 'Letter Template';
    });
    const templateText = {
      title: 'Letter Template',
      desc: letterTemplate,
    };
    templatesTemp.push(templateText);
    const letterTemplateCopy = {
      value: languageId,
      text: letterTemplate,
    };
    if (this.state.letterTemplate && (letterTemplate.trim() !== '' || this.state.letterTemplate.value.trim() !== '') && (letterTemplate.trim() !== 'Choose One' || this.state.letterTemplate.text.trim() !== 'Choose One')) {
      const validMsgState = (this.state.messageType.value === 'custom' && this.state.englishMessage !== '') || this.state.predefMessageData.englishLanguage !== '';
      if(validMsgState) {
        this.setState({
          merchantMsgPresent : true
        }, () => {
          this.onDisableNextStep(false)
        })
      }
    } else {
      this.setState({
        merchantMsgPresent : false
      }, () => {
        this.onDisableNextStep(true)
      })
    }
    const updateIndex = templatesTemp.findIndex((issuerActionData) => {
      return issuerActionData.title?.includes('Language') && !issuerActionData.title?.includes('English');
    });

    this.setState({
      merchantMessageTemp: templatesTemp,
      letterTemplate: letterTemplateCopy,
    });

    const updatedMerchantMessage = { ...this.state.merchantMessage };
    updatedMerchantMessage.letterTemplateLanguageId = languageId;
    updatedMerchantMessage.merchPrefLangLetterMessage = updateIndex !== -1 ? templatesTemp[updateIndex].desc : '';
    this.setState({
      merchantMessage: updatedMerchantMessage,
    });
  }

  disableRoundButtons(selectedIssuerIndex) {
    const buttonStatus = this.state.buttonStatus.find(
      (item) => item.selectedActionIssuerId == this.state.selectedActionIssuerId,
    );
    if (buttonStatus !== undefined && !buttonStatus.status && selectedIssuerIndex == this.state.selectedIssuerIndex + 1) {
      return false;
    }
    if (selectedIssuerIndex <= this.state.selectedIssuerIndex) {
      return false;
    } else {
      return true;
    }
  }

  checkErrorFlag(errorMsg) {
    this.setState({ isMerchantMessageError: errorMsg });
  }

  setQuestionnaireData(questionaireData) {
    this.setState({
      questionnaireData: questionaireData.dataColumns,
      levelOneInitialQuesDataColumns: questionaireData.initialDataColumns,
      prevLevelThreeQuesDataColumns: questionaireData.prevLevelThreeDataColumns,
      attachArrayQuesColumns: questionaireData.attachArrayColumns,
      levelOneComponents: questionaireData.levelOneComponents,
      levelTwoComponents: questionaireData.levelTwoComponents,
      levelThreeComponents: questionaireData.levelThreeComponents,
    })
  }

  setVisaQuestionnaireSubmitData(submitResponseData, disputeResponseReason, disputeType, reasonCode) {
    let visaQuestionnaireData = {
      "disputeResponseReason": disputeResponseReason,
      "disputeType": disputeType,
      "reasonCode": reasonCode,
      "response": submitResponseData
    }
    this.setState({ visaQuestionnaire: visaQuestionnaireData });
  }

  isActionDataLoading() {
    const selectedActionId = parseInt(this.state.selectedActionId);
    switch (selectedActionId) {
      case ActionConstants.__RESPOND_TO_CARD_BRAND_ID__:
        if (this.state.isLoadingActionDescriptions !== undefined) {
          return (this.state.isLoadingActionDescriptions);
        } else {
          return true;
        }
      case ActionConstants.__UNABLETO_FULFILL_ID__:
        if (this.state.isLoadingActionDescriptions !== undefined) {
          return (this.state.isLoadingActionDescriptions || this.state.isMerchantDataLoading || this.state.isFetchLetterInProgress);
        } else {
          return true;
        }
      case ActionConstants.__RESPOND_TO_ISSUER_ID__:
      case ActionConstants.__WRITEOFF_GOODWILL_ID__:
      case ActionConstants.__UNABLE_TO_DEFEND_PURSUE_ID__:
      case ActionConstants.__UNABLETO_FULFILL_ID__:
      case ActionConstants.__RESPOND_TO_CARD_BRAND_ID__:
        if (this.state.isLoadingActionDescriptions !== undefined) {
          return (this.state.isLoadingActionDescriptions || this.state.isMerchantDataLoading || this.state.isFetchLetterInProgress || this.state.isFetchingLedger || this.state.isFinancialAdjustmentDataLoading);
        } else {
          return true;
        }
      case ActionConstants.__PURSUE_CASE_FILLING_ID__:
        if (this.state.isImageDataLoading !== undefined) {
          return (this.state.isPrimaryRulesLoading || this.state.isCaseFilingTypesLoading || this.state.isMerchantDataLoading || this.state.isFetchLetterInProgress || this.state.isFetchingLedger || this.state.isFinancialAdjustmentDataLoading);
        } else {
          return true;
        }

      case ActionConstants.__REQUEST_ADDITIONAL_INFO_ID__:
        if (this.state.isImageDataLoading != undefined) {
          return (this.state.isMerchantDataLoading || this.state.isFetchLetterInProgress);
        } else {
          return true;
        }
      case ActionConstants.__NOTIFY_REQUEST_DOCS_ID__:
        if (this.state.isImageDataLoading != undefined) {
          return (this.state.isMerchantDataLoading || this.state.isFetchLetterInProgress || this.state.isFetchingLedger || this.state.isFinancialAdjustmentDataLoading);
        } else {
          return true;
        }
      case ActionConstants.__REQUEST_ISSUER_DOCUMENT_ID__:
        if (this.state.isLoadingActionDescriptions !== undefined) {
          return (this.state.isLoadingActionDescriptions);
        } else {
          return true;
        }
      case ActionConstants.__TRANSFER_CASE_ID__:
        return (this.state.isTransferListLoading || this.state.isTransferPurposeLoading);

      case ActionConstants.__CLOSE_CASE_ID__:
        return (this.state.isMerchantDataLoading || this.state.isFetchLetterInProgress || this.state.isFetchingLedger || this.state.isFinancialAdjustmentDataLoading);

    }
  }
  setInputTextAndDate(date, inputText) {
    const selectedActionIssuerId = this.state.jsonHeadings[this.state.selectedIssuerIndex].id;
    const updateIndex = this.state.issuerActionData.findIndex((issuerActionData) => {
      return issuerActionData.selectedActionIssuerId === selectedActionIssuerId;
    });
    let issuerActionData = [...this.state.issuerActionData];
    if (updateIndex !== -1) {
      issuerActionData[updateIndex].date = date;
      issuerActionData[updateIndex].inputText = inputText;
    }
    this.setState({
      issuerActionData,
      date,
      inputText
    });

  }

  checkInstitutionNameAndSetWarning = (nextProps) => {
    if (nextProps.acquirerCode === "MXP") {
      const caseNumber = nextProps.caseNumber;
  checkInstitutionName(caseNumber)
    .then((res) => {
      // If institutionPresent is true, do NOT show the warning
      // If institutionPresent is false, show the warning
      if (res.status && (res.status.statusCode === 2000 || res.status.statusCode === 200)) {
        if (res.data === true) {
          this.setState({
            showIssuerDocWarning: false,
            issuerDocWarningMessage: ""
          });
        } else {
          this.setState({
            showIssuerDocWarning: true,
            issuerDocWarningMessage: "Annex-8 will not auto generate because of the missing value for Issuer name field. Please attach Annex-8 manually"
          });
        }
      } 
    })
    .catch((error) => {
      // Network or server error, show warning
      this.setState({
        showIssuerDocWarning: false,
        issuerDocWarningMessage: "Institution name check failed."
      });
      console.log('Error Occurred while checking institution name', error);
    });
    } else {
      this.setState({
        showIssuerDocWarning: false,
        issuerDocWarningMessage: ""
      });
    }
  }

  resetTextAndDate(date, inputText) {
    this.setInputTextAndDate(date, inputText);
  }

  onActionValidationClick(actionClickType, index) {
    if(this.state.jsonHeadings[this.state.selectedIssuerIndex].reviewScreenKey == "financialAdjustment" && (disputeStages.indexOf(this.props.caseStageDetail.disputeStageId) !== -1) && (acquirerCodes.indexOf(this.props.acquirerCode) !== -1) && this.state.customWarningMessage == "") {
      if(actionClickType == "NUMBER_CLICK"){
        if(this.state.selectedIssuerIndex < index){
          this.checkDuplicateFinancials();
        } else {
          this.onPageChange(index);
        }
      } else{
        this.checkDuplicateFinancials();
      }
    }
    else if(this.state.jsonHeadings[this.state.selectedIssuerIndex].reviewScreenKey == "documentsToIssuer" && (acquirerCodes.indexOf(this.props.acquirerCode) !== -1) && (this.props.acquirerCode == "MXP"|| this.props.acquirerCode == "EMD")){
      if(actionClickType == "NUMBER_CLICK"){
        if(this.state.selectedIssuerIndex < index){
          this.validateAttachedDocSize();
        } else {
          this.onPageChange(index);
        }
      } else{
        if (["EMD", "MXP"].includes(this.props.acquirerCode)) {
          if (this.validateNoConversionDoc()) {

             this.validateAttachedDocSize(); // Stay on the same page if the validation fails
          }else {
            return;
          }
        } else {
          this.validateAttachedDocSize();
        }
      }
    }
    else {
      if(actionClickType == "NUMBER_CLICK") {
        this.onPageChange(index);
      }
      if(actionClickType == "NEXT_BTN_CLICK") {
        this.gotoNextStep();
      }
    }
  }
  
  render() {
    const wrapperClass = classnames('action-pane', {
      hidden: !this.state.isVisible,
      show: !this.props.isActiveStagePresent && this.state.isVisible,
      activeWarning: this.props.isActiveStagePresent && this.state.isVisible,
    });
    const checkBoxItem = this.state.checkBoxStatus.find(
      (item) => item.selectedActionIssuerId == this.state.selectedActionIssuerId,
    );
    var buttonStatus = this.state.buttonStatus.find(
      (item) => item.selectedActionIssuerId == this.state.selectedActionIssuerId,
    );
    const selectedIssuerData = this.state.issuerActionData.find(
      (item) => item.selectedActionIssuerId == this.state.selectedActionIssuerId,
    );
    const selectedActionIssuerIdData = this.state[this.state.selectedActionIssuerId];
    const isLoading = this.state.isLoading;
    const isLoadingActionData = this.isActionDataLoading();
    const issuerSelectionList = this.state.actionDescriptionList.find((selectedItem) => selectedItem.selectedActionIssuerId == this.state.selectedActionIssuerId);
    const initialResponseReasonList = selectedIssuerData ? this.getResponseReasonList(selectedIssuerData) : [];
    const description = this.setDescription(this.state.selectedIssuerIndex);
    const selectionList = issuerSelectionList !== undefined ? issuerSelectionList.finalSelectionList : this.state.caseFilingTypes ? this.state.caseFilingTypes : [];
    let caseAmount = this.state.setAcceptanceAmount  && this.state.setAcceptanceAmount[0];
    if(caseAmount && !showApiLedgerFlag ){
      defaultConfigLedgers =  JSON.parse(this.setAdjustmentLedgerForAcceptance(this.props.acquirerCode));
    }
    const annex19Warning = this.props.actionViewCode === "RTI" && this.props.acquirerCode === "EMD" && ["Chargeback", "Retrieval Request", "Incoming Pre-Arbitration"].includes(this.props.caseStageDetail.disputeStageName) ;
    let contentStyleClass = this.props.acquirerCode === "EMD" ? 'content-style-without-padding' : 'content-style' ;
  
    return (
      <div id="ActionPane" className={'scroll-margin'}>
        <div className={!isLoading ? wrapperClass : wrapperClass + ' opacity'} >
          {
            this.props.dataErr && (
              <EmptyState
                translations={{ emptyStateHeading: "Data not available.", emptyStateDescription: "Please try again later." }}
              />
            )
          }
          {this.showErrorBanner()}
          {this.showWarningBanner()}
          {this.setRequestAdditionalWarningBanner()}
          {this.showIssuerDocErrorBanner()}
          {!this.props.dataErr && <ul className={contentStyleClass}>
            <li>
              {this.state.isAnnex19Present && annex19Warning && !isLoadingActionData &&
                <div>
                <FinancialsBanner
                  extraclass="banner"
                  title={"Warning: This dispute may require documentation from the clearing house, including a POS Authorization Log with Transactional Details. Verify whether this information is needed before submitting a response to the card issuer."}
                  image={financialsLogo}
                  imageClass="financials-logo"
                />
                </div>
              }
              {this.state.isFinancialAdjustmentWarning &&
                <FinancialsBanner
                  extraclass="banner"
                  title={this.state.customWarningMessage}
                  image={financialsLogo}
                  imageClass="financials-logo"
                />
              }
              {this.state.jsonHeadings[this.state.selectedIssuerIndex]?.reviewScreenKey === "documentsToIssuer" && this.state.showIssuerDocWarning &&
                <FinancialsBanner
                extraclass="banner"
                title={this.state.issuerDocWarningMessage}
                image={financialsLogo}
                imageClass="financials-logo"
                />
				      }
            </li>
            <li>
              {this.props.selectedActionPanelDetailItem !== undefined && <div className="control-content" style={this.props.selectedActionPanelDetailItem.extraStyle}>
                {this.props.selectedActionPanelDetailItem.showProgressButton && (<ul className="button-style">
                  {this.state.jsonHeadings.map((item, index) => {
                    if (item.disabled == undefined || !item.disabled) {
                      return (<li key={'numbered-round-button-'+index}>
                        <NumberedRoundButton
                          category={this.state.selectedIssuerIndex == index ? 'numbered-round-active' : 'numbered-round'}
                          action={() => {this.onActionValidationClick("NUMBER_CLICK", index)}}
                          id="info"
                          tooltipTitle={this.setDescription(index)}
                          disabled={this.disableRoundButtons(index)}
                        >
                          <span className={this.state.selectedIssuerIndex == index ? 'button-text-active' : ' button-text'}>{index + 1}</span>
                        </NumberedRoundButton>

                      </li>);
                    }
                  },
                  )}
                </ul>)}
                <div className="headings">
                  {this.state.jsonHeadings[this.state.selectedIssuerIndex] !== undefined && this.state.jsonHeadings[this.state.selectedIssuerIndex].title !== undefined && <div className="headings-fixed"> {this.state.jsonHeadings[this.state.selectedIssuerIndex].title}</div>}
                  {this.state.jsonHeadings[this.state.selectedIssuerIndex] !== undefined && <div className={`${description === 'Transfer Case' ? 'headings-transfer-color' : 'headings-change'}`}>{description}</div>}
                </div>
                {this.state.jsonHeadings[this.state.selectedIssuerIndex] !== undefined && this.state.jsonHeadings[this.state.selectedIssuerIndex].info !== undefined && <div style={{ fontSize: 14, fontWeight: 600, color: '#595959', whiteSpace: 'pre-wrap', width: 260, paddingLeft: 15, paddingTop: 11 }}>{this.state.jsonHeadings[this.state.selectedIssuerIndex].info}</div>}
              </div>}

            </li>
            <li>
              {isLoading && <div className="actionLoader"><BVLoader20 /></div>}
              {isLoadingActionData && <BVLoader20 />}
              {this.state.isFinancialsDataLoading && <BVLoader20 isFinancialsDataLoading={true} bgColor="rgba(255, 255, 255, 0.93)" />}
              <div style={{ visibility: this.state.isFinancialsDataLoading ? "hidden" : "visible" }}className={isLoadingActionData ? "dynamic-content-borderless" : "dynamic-content"} >
                {this.checkImageLoadingStatus(this.state.selectedIssuerIndex) && <BVLoader20 />}
                {!isLoadingActionData && !this.checkImageLoadingStatus(this.state.selectedIssuerIndex) && this.state.showComponent && this.props.selectedActionPanelDetailItem !== undefined &&
                  <ActionIssuerComponents
                    disputeStageId={this.props.caseStageDetail.disputeStageId}
                    skipNotifyMerchant={this.skipNotifyMerchant}
                    skipNotifyMerchantState={this.state.skipNotifyMerchant}
                    updateCheckBoxStatus={this.updateCheckBoxStatus}
                    merchantMessage={this.state.merchantMessage}
                    reasonForAdditionalReviewLength={this.state.reasonForAdditionalReviewLength}
                    showQuesCurrency={this.state.showQuesCurrency}
                    asyncLoading={this.state.isImageDataLoading}
                    issuerIndex={this.state.selectedIssuerIndex}
                    jsonHeadings={this.state.jsonHeadings}
                    onDisableNextStep={this.onDisableNextStep}
                    style={{ float: 'right' }}
                    selectionList={selectionList}
                    responseReasonList={initialResponseReasonList && initialResponseReasonList.length > 0 ? initialResponseReasonList : this.state.secondaryDropDownList !== undefined ? this.state.secondaryDropDownList : []}
                    onEndEdit={this.onEndEdit}
                    caseNumber={this.props.caseNumber}
                    merchantNumber={this.props.merchantNumber}
                    isDataUploaded={this.props.isDataUploaded}
                    isError={this.state.isError}
                    attachDocumentPage={this.attachDocumentPage}
                    selectedActionPanelId={this.state.selectedActionPanelId}
                    checkBoxStatus={checkBoxItem == undefined ? [false, false, false, false] : checkBoxItem.status}
                    textAreaValue={selectedIssuerData !== undefined ? selectedIssuerData.note : ''}
                    length={selectedIssuerData !== undefined ? selectedIssuerData.length : 0}
                    showCharCount={selectedIssuerData !== undefined ? selectedIssuerData.showCharCount : false}
                    selectedOption={selectedIssuerData !== undefined ? selectedIssuerData.selectedOption : null}
                    buttonClick={this.onPageChange}
                    acquirerCode={this.props.acquirerCode}
                    merchantRegionCode={this.props.merchantRegionCode}
                    caseDocuments={this.props.caseDocuments}
                    updateSelectedCaseDocuments={this.updateSelectedCaseDocuments}
                    date={this.state.date}
                    inputText={this.state.inputText}
                    selectedActionIssuerId={this.state.selectedActionIssuerId}
                    updatePageListArray={this.updatePageListArray}
                    fetchEnglishMessageData={this.fetchEnglishMessageData}
                    fetchOtherMessageData={this.fetchOtherMessageData}
                    fetchPredefMessageData={this.fetchPredefMessageData}
                    fetchMerchantDocumentFlag={this.fetchMerchantDocumentFlag}
                    fetchLangId={this.fetchLangId}
                    caseStageId={this.state.caseStageId}
                    getAdjustFinancialDataForReview={this.getAdjustFinancialDataForReview}
                    issuerActionData={this.state.issuerActionData}
                    merchantMessageTemp={this.state.merchantMessageTemp}
                    messageType={this.state.messageType}
                    isMerchantMessageError={this.state.isMerchantMessageError}
                    letterTemplate={this.state.letterTemplate}
                    isAttachDocuments={this.state.merchantMessage.merchantDocumentsProvided}
                    englishMessage={this.state.englishMessage}
                    otherMessage={this.state.otherMessage}
                    predefMessage={this.state.predefMessageData}
                    fetchMessageType={this.fetchMessageType}
                    ledgers={this.state.ledgers.filter(item => !item.value.includes("4071"))}
                    isFinancialLossOccured={selectedActionIssuerIdData !== undefined && selectedActionIssuerIdData.isFinancialLossOccured !== undefined ? selectedActionIssuerIdData.isFinancialLossOccured : undefined}
                    acceptFinancialLoss={this.acceptFinancialLoss}
                    getLiabilityData={this.getLiabilityData}
                    adjustmentLedger={showApiLedgerFlag ? apiLedgerData : defaultConfigLedgers}
                    financialData={this.state.financialData}
                    balanceAmount={this.props.balanceAmount}
                    handleSingleDateChange={this.handleSingleDateChange}
                    prePopulateDate={this.prePopulateDate}
                    pendDate={this.state.pendDate}
                    daysLeft={this.state.daysLeft}
                    todayDate={this.state.todayDate}
                    dateFormat={this.state.dateFormat}
                    setActionData={this.setActionData}
                    checkBoxFlag={this.checkBoxFlag}
                    settingReturnToPDRFlag={this.settingReturnToPDRFlag}
                    settingReasonForAdditionalReview={this.settingReasonForAdditionalReview}
                    attachArray={this.state.attachArray}
                    selectedActionId={this.state.selectedActionId}
                    transferUserList={this.state.transferUserList}
                    checkErrorFlag={this.checkErrorFlag}
                    predefMessages={this.state.predefMessages}
                    languageIndCode={this.state.languageIndCode}
                    languageText={this.state.languageText}
                    letterTemplates={this.state.letterTemplates}
                    selections={this.state.selections}
                    isMerchantMessageAvailable={this.state.isMerchantMessageAvailable}
                    reasonCode={this.getReasonCode(this.props.caseStageDetail.disputeReasonCode)} //10,11 allocation and 12 ,13 collaboration
                    cardBrand={this.props.caseStageDetail.cardBrandCode == ActionConstants.__VISA_BRAND_CODE__ ? ActionConstants.__VISA_BRAND_NAME__ : this.props.caseStageDetail.cardBrandCode == ActionConstants.__MASTERCARD_BRAND_CODE__ ? ActionConstants.__MASTERCARD_BRAND_NAME__ : ActionConstants.__DISCOVER_BRAND_NAME__}
                    supportDocumentInd={this.state.supportDocumentInd}
                    setQuestionnaireData={this.setQuestionnaireData}
                    questionDataColumns={this.state.questionnaireData}
                    levelOneInitialQuesDataColumns={this.state.levelOneInitialQuesDataColumns}
                    prevLevelThreeQuesDataColumns={this.state.prevLevelThreeQuesDataColumns}
                    attachArrayQuesColumns={this.state.attachArrayColumns}
                    levelTwoComponents={this.state.levelTwoComponents}
                    levelThreeComponents={this.state.levelThreeComponents}
                    levelOneComponents={this.state.levelOneComponents}
                    disputeStageName={this.props.caseStageDetail.disputeStageName}
                    reasonCodeCategoryDesc={this.props.caseStageDetail.reasonCodeCategoryDesc}
                    reasonCodeCategory={this.props.caseStageDetail.reasonCodeCategory}
                    setVisaQuestionnaireSubmitData={this.setVisaQuestionnaireSubmitData}
                    representmentAmount={this.state.representmentAmount}
                    fileUploaded={this.fileUploaded}
                    uploadFileList={this.state.uploadFileList}
                    isDisabledHandler={this.isDisabledHandler}
                    updateNextButtonStatus={this.updateNextButtonStatus}
                    merchantCurrencyCode={this.props.merchantCurrencyCode}
                    transactionDate={this.props.transactionDate}
                    disputeAmount={this.props.caseStageDetail.disputeAmount}
                    disputeCurrencyCode={this.props.disputeCurrencyCode}
                    conversionRate={this.state.conversionRate}
                    usdToGBPRate={this.state.usdToGBPRate}
                    gbptoUSDRate={this.state.gbptoUSDRate}
                    merchantRate={this.state.merchantRate}
                    setInputTextAndDate={this.setInputTextAndDate}
                    resetTextAndDate={this.resetTextAndDate}
                    actionViewCode={this.state.actionViewCode}
                    setActionPanelJsonData={this.setActionPanelJsonData}
                    issuerProps={this.props}
                    userPermissions={this.props.userPermissions}
                    showApiLedgerFlag={showApiLedgerFlag}
                    cardBrandCode = {this.props.caseStageDetail.cardBrandCode}
                    transactioncode={this.props.transactioncode}
                    foreignDomesticIndicator={this.props.foreignDomesticIndicator}
                    visaQnReviewData={this.state.visaQnReviewData}
                    setQuestionnaireReviewData={this.setQuestionnaireReviewData}
                    cardBrandDueDate={this.props.cardBrandDueDate}
                  />}
              </div>
            </li>
          </ul>
          }
          <div className="action-pane__footer" >
            <Button
              action={this.setCancelResponseBanner}
              extraClass="clear clear-button"
              category="link-inline"
              id={'1_btn_clear'}
              disabled={this.state.isSubmitButtonClicked !== undefined ? this.state.isSubmitButtonClicked : false}
            >
              <strong> {this.state.cancelButtonText}</strong>
            </Button>
            <div className="action-pane__footer-right" >
              {this.state.secondaryButtonText !== '' && this.state.secondaryButtonText !== undefined && <Button
                action={this.previousIssuerPage}
                category="link-inline"
                id={'1_btn_prev'}
                style={{ marginRight: 25 }}
                disabled={this.state.isSubmitButtonClicked !== undefined ? this.state.isSubmitButtonClicked : false}
                extraClass="prev-button"
              >
                <strong> {this.state.secondaryButtonText}</strong>
              </Button>}
              {this.state.primaryButtonText !== undefined && <PrimaryButton
                action={this.state.jsonHeadings !== undefined && this.state.jsonHeadings.length - 1 == this.state.selectedIssuerIndex && this.state.closeCaseSubmitPerform === true ? this.submitAction : () => { this.onActionValidationClick("NEXT_BTN_CLICK", 0)}}
                extraClass={this.state.jsonHeadings !== undefined && this.state.jsonHeadings.length - 1 == this.state.selectedIssuerIndex && this.props.selectedActionPanelDetailItem !== undefined ? '' : this.props.selectedActionPanelDetailItem !== undefined ? this.props.selectedActionPanelDetailItem.extraPrimaryButtonClass : ''}
                id={this.state.primaryButtonText && this.state.primaryButtonText.toLowerCase().includes('submit') ? '1_btn_apply' : '1_btn_next'}
                style={{ width: 140, height: 42 }}
                disabled={buttonStatus == undefined ? true : !buttonStatus.status ? (this.state.isSubmitButtonClicked !== undefined ? this.state.isSubmitButtonClicked : false) : true}
              >
                <strong>{this.state.primaryButtonText}</strong>
              </PrimaryButton>}
              {
                this.state.submitButtonText !== undefined && this.state.primaryButtonText == undefined && <PrimaryButton
                  id={'1_btn_apply'}
                  action={this.submitAction}
                  style={{ width: 140, height: 42 }}
                  disabled={buttonStatus == undefined ? true : !buttonStatus.status ? (this.state.isSubmitButtonClicked !== undefined ? this.state.isSubmitButtonClicked : false) : true}
                >
                  <strong>{this.state.submitButtonText}</strong>
                </PrimaryButton>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }

  setDescription(index) {
    let selectedIssuerData = this.state.issuerActionData[0];
    if(!showApiLedgerFlag){
      return this.state.jsonHeadings[index].attachType == ActionConstants.__ADJUST_FINANCIAL__ ? "Adjust Financials" : this.state.jsonHeadings[index].description;
    }
    return selectedIssuerData && this.state.actionViewCode == 'PCF' && selectedIssuerData.selectedOption && selectedIssuerData.selectedOption[0] && selectedIssuerData.selectedOption[0].text.trim().toLowerCase() == "initiate pre-compliance" && this.state.jsonHeadings[index].description && this.state.jsonHeadings[index].description == "Send Documents to Card Brand" ? "Send Documents to Issuer" : index !== -1 && this.state.jsonHeadings[index] && this.state.jsonHeadings[index].description ? this.state.jsonHeadings[index].description : '';
  }

  checkImageLoadingStatus(selectedIssuerIndex) {
    return this.state.jsonHeadings && this.state.jsonHeadings[selectedIssuerIndex] && this.state.jsonHeadings[selectedIssuerIndex].description.toLowerCase().indexOf('send documents') !== -1 && this.state.isImageDataLoading;
  }

  getResponseReasonList(selectedIssuerData) {
    if (selectedIssuerData.selectedOption && selectedIssuerData.selectedOption[0] && this.props.actionViewCode == __PCF_ACTION_CODE__) {
      if (selectedIssuerData.selectedOption[0].text.toLowerCase() == __CREATE_GOOD_FAITH.toLowerCase()) {
        return __GOOD_FAITH_TYPES__//this.state.goodFaithTypes;
      }
      else if (selectedIssuerData.selectedOption[0].text.toLowerCase() == __FILE_COMPLIANCE__.toLowerCase() || selectedIssuerData.selectedOption[0].text.toLowerCase() == __INITIATE_PRE_COMPLIANCE__.toLowerCase()) {
        return this.state.primaryRuleViolationList;
      }
    }
    return [];
  }
}

IssuerActions.propTypes = {
  isVisible: PropTypes.bool,
  acquirerCode: PropTypes.string,
  merchantRegionCode: PropTypes.string,
  adjustFinancialsData: PropTypes.object,
  merchantNumber: PropTypes.string.isRequired,
  regionCode: PropTypes.string,
  closeNotification: PropTypes.func,
  balanceAmount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  resetNestedFieldSelectorData: PropTypes.func.isRequired,
  nestedFieldSelectorData: PropTypes.object,
  dataErr: PropTypes.bool,
  userPermission: PropTypes.object,
  cardBrandDueDate : PropTypes.string,
};

IssuerActions.defaultProps = {
  isVisible: false,
  dataErr: false,
  userPermission: {},
  cardBrandDueDate: "01/01/2199"
};

const mapStateToProps = (state) => ({
  adjustFinancialsData: transformDataForReviewScreen(state.nestedFieldSelectorData),
  balanceAmount: computeBalanceFromInputField(state.nestedFieldSelectorData),
  nestedFieldSelectorData: state.nestedFieldSelectorData,
  caseDocuments: state.caseDocuments
});

const mapDispatchToProps = (dispatch) => {
  return {
    resetNestedFieldSelectorData: (dataToBeUpdated) => {
      dispatch(resetNestedFieldSelectorData(dataToBeUpdated));
    },
    fetchDocumentsForCase: (caseNumber, documentTypes) => {
      dispatch(fetchDocumentsForCase(caseNumber, documentTypes));
    },
    resetDocumentsForCase: () => {
      dispatch(resetDocumentsForCase());
    },
    updateSelectedCasePages: (documentType, orderOfSelectedPages, imageOrderSeq, selectedPages, selectedFileIndex, pageCount, selectAllFlag) => {
      dispatch(updateSelectedCasePages(documentType, orderOfSelectedPages, imageOrderSeq, selectedPages, selectedFileIndex, pageCount, selectAllFlag))
    },
    updateEditedPages: (documentType, selectedPages, pageListArray, imageToolKitData) => {
      dispatch(updateEditedPages(documentType, selectedPages, pageListArray, imageToolKitData));
    },
    resetSelectedDocuments: (documentType) => {
      dispatch(resetSelectedDocuments(documentType));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IssuerActions);


